(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "../../../libs/custom-material/src/index.ts":
/*!***********************************************************************!*\
  !*** D:/Industrylinq/servicekicker/libs/custom-material/src/index.ts ***!
  \***********************************************************************/
/*! exports provided: MY_FORMATS, CustomMaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _lib_custom_material_module__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/custom-material.module */ "../../../libs/custom-material/src/lib/custom-material.module.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return _lib_custom_material_module__WEBPACK_IMPORTED_MODULE_1__["MY_FORMATS"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomMaterialModule", function() { return _lib_custom_material_module__WEBPACK_IMPORTED_MODULE_1__["CustomMaterialModule"]; });





/***/ }),

/***/ "../../../libs/custom-material/src/lib/custom-material.module.ts":
/*!********************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/libs/custom-material/src/lib/custom-material.module.ts ***!
  \********************************************************************************************/
/*! exports provided: MY_FORMATS, CustomMaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomMaterialModule", function() { return CustomMaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/layout */ "../../../node_modules/@angular/cdk/esm2015/layout.js");
/* harmony import */ var _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/autocomplete */ "../../../node_modules/@angular/material/esm2015/autocomplete.js");
/* harmony import */ var _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/bottom-sheet */ "../../../node_modules/@angular/material/esm2015/bottom-sheet.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/button */ "../../../node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/card */ "../../../node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/checkbox */ "../../../node_modules/@angular/material/esm2015/checkbox.js");
/* harmony import */ var _angular_material_chips__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/chips */ "../../../node_modules/@angular/material/esm2015/chips.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/core */ "../../../node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/datepicker */ "../../../node_modules/@angular/material/esm2015/datepicker.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/dialog */ "../../../node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/divider */ "../../../node_modules/@angular/material/esm2015/divider.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/expansion */ "../../../node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/form-field */ "../../../node_modules/@angular/material/esm2015/form-field.js");
/* harmony import */ var _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/grid-list */ "../../../node_modules/@angular/material/esm2015/grid-list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/icon */ "../../../node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/input */ "../../../node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/list */ "../../../node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/menu */ "../../../node_modules/@angular/material/esm2015/menu.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/paginator */ "../../../node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/progress-bar */ "../../../node_modules/@angular/material/esm2015/progress-bar.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/progress-spinner */ "../../../node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/radio */ "../../../node_modules/@angular/material/esm2015/radio.js");
/* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/select */ "../../../node_modules/@angular/material/esm2015/select.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/sidenav */ "../../../node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/material/slide-toggle */ "../../../node_modules/@angular/material/esm2015/slide-toggle.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/snack-bar */ "../../../node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @angular/material/sort */ "../../../node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_stepper__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material/stepper */ "../../../node_modules/@angular/material/esm2015/stepper.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @angular/material/table */ "../../../node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_tabs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @angular/material/tabs */ "../../../node_modules/@angular/material/esm2015/tabs.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @angular/material/toolbar */ "../../../node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @angular/material/tooltip */ "../../../node_modules/@angular/material/esm2015/tooltip.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @angular/material-moment-adapter */ "../../../node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");




































const MY_FORMATS = {
    parse: {
        dateInput: 'dddd LL',
    },
    display: {
        dateInput: 'dddd LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
let CustomMaterialModule = class CustomMaterialModule {
};
CustomMaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_3__["LayoutModule"],
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_4__["MatAutocompleteModule"],
            _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_5__["MatBottomSheetModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_7__["MatCardModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_8__["MatCheckboxModule"],
            _angular_material_chips__WEBPACK_IMPORTED_MODULE_9__["MatChipsModule"],
            _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_12__["MatDialogModule"],
            _angular_material_divider__WEBPACK_IMPORTED_MODULE_13__["MatDividerModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_14__["MatExpansionModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_15__["MatFormFieldModule"],
            _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_16__["MatGridListModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_17__["MatIconModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_18__["MatInputModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_19__["MatListModule"],
            _angular_material_menu__WEBPACK_IMPORTED_MODULE_20__["MatMenuModule"],
            // MatNativeDateModule,
            _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_35__["MatMomentDateModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_21__["MatPaginatorModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_23__["MatProgressSpinnerModule"],
            _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_22__["MatProgressBarModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_24__["MatRadioModule"],
            _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatRippleModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_25__["MatSelectModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_26__["MatSidenavModule"],
            _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_27__["MatSlideToggleModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__["MatSnackBarModule"],
            _angular_material_stepper__WEBPACK_IMPORTED_MODULE_30__["MatStepperModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_29__["MatSortModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_31__["MatTableModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_32__["MatTabsModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_33__["MatToolbarModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_34__["MatTooltipModule"],
        ],
        exports: [
            _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_3__["LayoutModule"],
            _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_4__["MatAutocompleteModule"],
            _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_5__["MatBottomSheetModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_7__["MatCardModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_8__["MatCheckboxModule"],
            _angular_material_chips__WEBPACK_IMPORTED_MODULE_9__["MatChipsModule"],
            _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_12__["MatDialogModule"],
            _angular_material_divider__WEBPACK_IMPORTED_MODULE_13__["MatDividerModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_14__["MatExpansionModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_15__["MatFormFieldModule"],
            _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_16__["MatGridListModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_17__["MatIconModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_18__["MatInputModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_19__["MatListModule"],
            _angular_material_menu__WEBPACK_IMPORTED_MODULE_20__["MatMenuModule"],
            // MatNativeDateModule,
            _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_35__["MatMomentDateModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_21__["MatPaginatorModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_23__["MatProgressSpinnerModule"],
            _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_22__["MatProgressBarModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_24__["MatRadioModule"],
            _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatRippleModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_25__["MatSelectModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_26__["MatSidenavModule"],
            _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_27__["MatSlideToggleModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__["MatSnackBarModule"],
            _angular_material_stepper__WEBPACK_IMPORTED_MODULE_30__["MatStepperModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_29__["MatSortModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_31__["MatTableModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_32__["MatTabsModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_33__["MatToolbarModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_34__["MatTooltipModule"],
        ],
        providers: [
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ]
    })
], CustomMaterialModule);



/***/ }),

/***/ "../../../node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!******************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/moment/locale sync ^\.\/.*$ ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "../../../node_modules/moment/locale/af.js",
	"./af.js": "../../../node_modules/moment/locale/af.js",
	"./ar": "../../../node_modules/moment/locale/ar.js",
	"./ar-dz": "../../../node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "../../../node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "../../../node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "../../../node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "../../../node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "../../../node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "../../../node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "../../../node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "../../../node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "../../../node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "../../../node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "../../../node_modules/moment/locale/ar-tn.js",
	"./ar.js": "../../../node_modules/moment/locale/ar.js",
	"./az": "../../../node_modules/moment/locale/az.js",
	"./az.js": "../../../node_modules/moment/locale/az.js",
	"./be": "../../../node_modules/moment/locale/be.js",
	"./be.js": "../../../node_modules/moment/locale/be.js",
	"./bg": "../../../node_modules/moment/locale/bg.js",
	"./bg.js": "../../../node_modules/moment/locale/bg.js",
	"./bm": "../../../node_modules/moment/locale/bm.js",
	"./bm.js": "../../../node_modules/moment/locale/bm.js",
	"./bn": "../../../node_modules/moment/locale/bn.js",
	"./bn.js": "../../../node_modules/moment/locale/bn.js",
	"./bo": "../../../node_modules/moment/locale/bo.js",
	"./bo.js": "../../../node_modules/moment/locale/bo.js",
	"./br": "../../../node_modules/moment/locale/br.js",
	"./br.js": "../../../node_modules/moment/locale/br.js",
	"./bs": "../../../node_modules/moment/locale/bs.js",
	"./bs.js": "../../../node_modules/moment/locale/bs.js",
	"./ca": "../../../node_modules/moment/locale/ca.js",
	"./ca.js": "../../../node_modules/moment/locale/ca.js",
	"./cs": "../../../node_modules/moment/locale/cs.js",
	"./cs.js": "../../../node_modules/moment/locale/cs.js",
	"./cv": "../../../node_modules/moment/locale/cv.js",
	"./cv.js": "../../../node_modules/moment/locale/cv.js",
	"./cy": "../../../node_modules/moment/locale/cy.js",
	"./cy.js": "../../../node_modules/moment/locale/cy.js",
	"./da": "../../../node_modules/moment/locale/da.js",
	"./da.js": "../../../node_modules/moment/locale/da.js",
	"./de": "../../../node_modules/moment/locale/de.js",
	"./de-at": "../../../node_modules/moment/locale/de-at.js",
	"./de-at.js": "../../../node_modules/moment/locale/de-at.js",
	"./de-ch": "../../../node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "../../../node_modules/moment/locale/de-ch.js",
	"./de.js": "../../../node_modules/moment/locale/de.js",
	"./dv": "../../../node_modules/moment/locale/dv.js",
	"./dv.js": "../../../node_modules/moment/locale/dv.js",
	"./el": "../../../node_modules/moment/locale/el.js",
	"./el.js": "../../../node_modules/moment/locale/el.js",
	"./en-SG": "../../../node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "../../../node_modules/moment/locale/en-SG.js",
	"./en-au": "../../../node_modules/moment/locale/en-au.js",
	"./en-au.js": "../../../node_modules/moment/locale/en-au.js",
	"./en-ca": "../../../node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "../../../node_modules/moment/locale/en-ca.js",
	"./en-gb": "../../../node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "../../../node_modules/moment/locale/en-gb.js",
	"./en-ie": "../../../node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "../../../node_modules/moment/locale/en-ie.js",
	"./en-il": "../../../node_modules/moment/locale/en-il.js",
	"./en-il.js": "../../../node_modules/moment/locale/en-il.js",
	"./en-nz": "../../../node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "../../../node_modules/moment/locale/en-nz.js",
	"./eo": "../../../node_modules/moment/locale/eo.js",
	"./eo.js": "../../../node_modules/moment/locale/eo.js",
	"./es": "../../../node_modules/moment/locale/es.js",
	"./es-do": "../../../node_modules/moment/locale/es-do.js",
	"./es-do.js": "../../../node_modules/moment/locale/es-do.js",
	"./es-us": "../../../node_modules/moment/locale/es-us.js",
	"./es-us.js": "../../../node_modules/moment/locale/es-us.js",
	"./es.js": "../../../node_modules/moment/locale/es.js",
	"./et": "../../../node_modules/moment/locale/et.js",
	"./et.js": "../../../node_modules/moment/locale/et.js",
	"./eu": "../../../node_modules/moment/locale/eu.js",
	"./eu.js": "../../../node_modules/moment/locale/eu.js",
	"./fa": "../../../node_modules/moment/locale/fa.js",
	"./fa.js": "../../../node_modules/moment/locale/fa.js",
	"./fi": "../../../node_modules/moment/locale/fi.js",
	"./fi.js": "../../../node_modules/moment/locale/fi.js",
	"./fo": "../../../node_modules/moment/locale/fo.js",
	"./fo.js": "../../../node_modules/moment/locale/fo.js",
	"./fr": "../../../node_modules/moment/locale/fr.js",
	"./fr-ca": "../../../node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "../../../node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "../../../node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "../../../node_modules/moment/locale/fr-ch.js",
	"./fr.js": "../../../node_modules/moment/locale/fr.js",
	"./fy": "../../../node_modules/moment/locale/fy.js",
	"./fy.js": "../../../node_modules/moment/locale/fy.js",
	"./ga": "../../../node_modules/moment/locale/ga.js",
	"./ga.js": "../../../node_modules/moment/locale/ga.js",
	"./gd": "../../../node_modules/moment/locale/gd.js",
	"./gd.js": "../../../node_modules/moment/locale/gd.js",
	"./gl": "../../../node_modules/moment/locale/gl.js",
	"./gl.js": "../../../node_modules/moment/locale/gl.js",
	"./gom-latn": "../../../node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "../../../node_modules/moment/locale/gom-latn.js",
	"./gu": "../../../node_modules/moment/locale/gu.js",
	"./gu.js": "../../../node_modules/moment/locale/gu.js",
	"./he": "../../../node_modules/moment/locale/he.js",
	"./he.js": "../../../node_modules/moment/locale/he.js",
	"./hi": "../../../node_modules/moment/locale/hi.js",
	"./hi.js": "../../../node_modules/moment/locale/hi.js",
	"./hr": "../../../node_modules/moment/locale/hr.js",
	"./hr.js": "../../../node_modules/moment/locale/hr.js",
	"./hu": "../../../node_modules/moment/locale/hu.js",
	"./hu.js": "../../../node_modules/moment/locale/hu.js",
	"./hy-am": "../../../node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "../../../node_modules/moment/locale/hy-am.js",
	"./id": "../../../node_modules/moment/locale/id.js",
	"./id.js": "../../../node_modules/moment/locale/id.js",
	"./is": "../../../node_modules/moment/locale/is.js",
	"./is.js": "../../../node_modules/moment/locale/is.js",
	"./it": "../../../node_modules/moment/locale/it.js",
	"./it-ch": "../../../node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "../../../node_modules/moment/locale/it-ch.js",
	"./it.js": "../../../node_modules/moment/locale/it.js",
	"./ja": "../../../node_modules/moment/locale/ja.js",
	"./ja.js": "../../../node_modules/moment/locale/ja.js",
	"./jv": "../../../node_modules/moment/locale/jv.js",
	"./jv.js": "../../../node_modules/moment/locale/jv.js",
	"./ka": "../../../node_modules/moment/locale/ka.js",
	"./ka.js": "../../../node_modules/moment/locale/ka.js",
	"./kk": "../../../node_modules/moment/locale/kk.js",
	"./kk.js": "../../../node_modules/moment/locale/kk.js",
	"./km": "../../../node_modules/moment/locale/km.js",
	"./km.js": "../../../node_modules/moment/locale/km.js",
	"./kn": "../../../node_modules/moment/locale/kn.js",
	"./kn.js": "../../../node_modules/moment/locale/kn.js",
	"./ko": "../../../node_modules/moment/locale/ko.js",
	"./ko.js": "../../../node_modules/moment/locale/ko.js",
	"./ku": "../../../node_modules/moment/locale/ku.js",
	"./ku.js": "../../../node_modules/moment/locale/ku.js",
	"./ky": "../../../node_modules/moment/locale/ky.js",
	"./ky.js": "../../../node_modules/moment/locale/ky.js",
	"./lb": "../../../node_modules/moment/locale/lb.js",
	"./lb.js": "../../../node_modules/moment/locale/lb.js",
	"./lo": "../../../node_modules/moment/locale/lo.js",
	"./lo.js": "../../../node_modules/moment/locale/lo.js",
	"./lt": "../../../node_modules/moment/locale/lt.js",
	"./lt.js": "../../../node_modules/moment/locale/lt.js",
	"./lv": "../../../node_modules/moment/locale/lv.js",
	"./lv.js": "../../../node_modules/moment/locale/lv.js",
	"./me": "../../../node_modules/moment/locale/me.js",
	"./me.js": "../../../node_modules/moment/locale/me.js",
	"./mi": "../../../node_modules/moment/locale/mi.js",
	"./mi.js": "../../../node_modules/moment/locale/mi.js",
	"./mk": "../../../node_modules/moment/locale/mk.js",
	"./mk.js": "../../../node_modules/moment/locale/mk.js",
	"./ml": "../../../node_modules/moment/locale/ml.js",
	"./ml.js": "../../../node_modules/moment/locale/ml.js",
	"./mn": "../../../node_modules/moment/locale/mn.js",
	"./mn.js": "../../../node_modules/moment/locale/mn.js",
	"./mr": "../../../node_modules/moment/locale/mr.js",
	"./mr.js": "../../../node_modules/moment/locale/mr.js",
	"./ms": "../../../node_modules/moment/locale/ms.js",
	"./ms-my": "../../../node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "../../../node_modules/moment/locale/ms-my.js",
	"./ms.js": "../../../node_modules/moment/locale/ms.js",
	"./mt": "../../../node_modules/moment/locale/mt.js",
	"./mt.js": "../../../node_modules/moment/locale/mt.js",
	"./my": "../../../node_modules/moment/locale/my.js",
	"./my.js": "../../../node_modules/moment/locale/my.js",
	"./nb": "../../../node_modules/moment/locale/nb.js",
	"./nb.js": "../../../node_modules/moment/locale/nb.js",
	"./ne": "../../../node_modules/moment/locale/ne.js",
	"./ne.js": "../../../node_modules/moment/locale/ne.js",
	"./nl": "../../../node_modules/moment/locale/nl.js",
	"./nl-be": "../../../node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "../../../node_modules/moment/locale/nl-be.js",
	"./nl.js": "../../../node_modules/moment/locale/nl.js",
	"./nn": "../../../node_modules/moment/locale/nn.js",
	"./nn.js": "../../../node_modules/moment/locale/nn.js",
	"./pa-in": "../../../node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "../../../node_modules/moment/locale/pa-in.js",
	"./pl": "../../../node_modules/moment/locale/pl.js",
	"./pl.js": "../../../node_modules/moment/locale/pl.js",
	"./pt": "../../../node_modules/moment/locale/pt.js",
	"./pt-br": "../../../node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "../../../node_modules/moment/locale/pt-br.js",
	"./pt.js": "../../../node_modules/moment/locale/pt.js",
	"./ro": "../../../node_modules/moment/locale/ro.js",
	"./ro.js": "../../../node_modules/moment/locale/ro.js",
	"./ru": "../../../node_modules/moment/locale/ru.js",
	"./ru.js": "../../../node_modules/moment/locale/ru.js",
	"./sd": "../../../node_modules/moment/locale/sd.js",
	"./sd.js": "../../../node_modules/moment/locale/sd.js",
	"./se": "../../../node_modules/moment/locale/se.js",
	"./se.js": "../../../node_modules/moment/locale/se.js",
	"./si": "../../../node_modules/moment/locale/si.js",
	"./si.js": "../../../node_modules/moment/locale/si.js",
	"./sk": "../../../node_modules/moment/locale/sk.js",
	"./sk.js": "../../../node_modules/moment/locale/sk.js",
	"./sl": "../../../node_modules/moment/locale/sl.js",
	"./sl.js": "../../../node_modules/moment/locale/sl.js",
	"./sq": "../../../node_modules/moment/locale/sq.js",
	"./sq.js": "../../../node_modules/moment/locale/sq.js",
	"./sr": "../../../node_modules/moment/locale/sr.js",
	"./sr-cyrl": "../../../node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "../../../node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "../../../node_modules/moment/locale/sr.js",
	"./ss": "../../../node_modules/moment/locale/ss.js",
	"./ss.js": "../../../node_modules/moment/locale/ss.js",
	"./sv": "../../../node_modules/moment/locale/sv.js",
	"./sv.js": "../../../node_modules/moment/locale/sv.js",
	"./sw": "../../../node_modules/moment/locale/sw.js",
	"./sw.js": "../../../node_modules/moment/locale/sw.js",
	"./ta": "../../../node_modules/moment/locale/ta.js",
	"./ta.js": "../../../node_modules/moment/locale/ta.js",
	"./te": "../../../node_modules/moment/locale/te.js",
	"./te.js": "../../../node_modules/moment/locale/te.js",
	"./tet": "../../../node_modules/moment/locale/tet.js",
	"./tet.js": "../../../node_modules/moment/locale/tet.js",
	"./tg": "../../../node_modules/moment/locale/tg.js",
	"./tg.js": "../../../node_modules/moment/locale/tg.js",
	"./th": "../../../node_modules/moment/locale/th.js",
	"./th.js": "../../../node_modules/moment/locale/th.js",
	"./tl-ph": "../../../node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "../../../node_modules/moment/locale/tl-ph.js",
	"./tlh": "../../../node_modules/moment/locale/tlh.js",
	"./tlh.js": "../../../node_modules/moment/locale/tlh.js",
	"./tr": "../../../node_modules/moment/locale/tr.js",
	"./tr.js": "../../../node_modules/moment/locale/tr.js",
	"./tzl": "../../../node_modules/moment/locale/tzl.js",
	"./tzl.js": "../../../node_modules/moment/locale/tzl.js",
	"./tzm": "../../../node_modules/moment/locale/tzm.js",
	"./tzm-latn": "../../../node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "../../../node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "../../../node_modules/moment/locale/tzm.js",
	"./ug-cn": "../../../node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "../../../node_modules/moment/locale/ug-cn.js",
	"./uk": "../../../node_modules/moment/locale/uk.js",
	"./uk.js": "../../../node_modules/moment/locale/uk.js",
	"./ur": "../../../node_modules/moment/locale/ur.js",
	"./ur.js": "../../../node_modules/moment/locale/ur.js",
	"./uz": "../../../node_modules/moment/locale/uz.js",
	"./uz-latn": "../../../node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "../../../node_modules/moment/locale/uz-latn.js",
	"./uz.js": "../../../node_modules/moment/locale/uz.js",
	"./vi": "../../../node_modules/moment/locale/vi.js",
	"./vi.js": "../../../node_modules/moment/locale/vi.js",
	"./x-pseudo": "../../../node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "../../../node_modules/moment/locale/x-pseudo.js",
	"./yo": "../../../node_modules/moment/locale/yo.js",
	"./yo.js": "../../../node_modules/moment/locale/yo.js",
	"./zh-cn": "../../../node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "../../../node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "../../../node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "../../../node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "../../../node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "../../../node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../../node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.html":
/*!*****************************************************************************************************************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.html ***!
  \*****************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--stuff to translate from component-->\r\n<span class=\"cdk-visually-hidden\" #invoiceDel i18n=\"@@sk-invoiceItemDeleted\">Invoice item has been deleted</span>\r\n<span class=\"cdk-visually-hidden\" #success i18n=\"@@sk-success\">Success</span>\r\n<span class=\"cdk-visually-hidden\" #archiveInvoice i18n=\"@@sk-archiveInvoice\">Archive Invoice</span>\r\n<span class=\"cdk-visually-hidden\" #returnDashboard\r\n      i18n=\"@@sk-returnInvoiceDashboard\">Return to invoice dashboard</span>\r\n<span class=\"cdk-visually-hidden\" #shouldDelete i18n=\"@@sk-shouldDeleteInvoiceItem\">Are you sure you want to delete this invoice item?</span>\r\n<span class=\"cdk-visually-hidden\" #yesText i18n=\"@@sk-yesText\">yes</span>\r\n<span class=\"cdk-visually-hidden\" #noText i18n=\"@@sk-noText\">no</span>\r\n<ng-container>{{translate(invoiceDel.innerHTML, success.innerHTML, archiveInvoice.innerHTML, returnDashboard.innerHTML,\r\n  shouldDelete.innerHTML, yesText.innerHTML, noText.innerHTML)}}</ng-container>\r\n<!---->\r\n<div *ngIf=\"!gotInvoiceDetail\" i18n=\"@@sk-noInvoiceItems\">\r\n  There are no invoices items.\r\n</div>\r\n\r\n<table *ngIf=\"gotInvoiceDetail && onReady\" mat-table class=\"sk-full-width-table\" [dataSource]=\"dataSource\" matSort\r\n       aria-label=\"Elements\">\r\n\r\n  <!-- Location Column -->\r\n  <ng-container matColumnDef=\"project\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n=\"@@sk-item\">Item</th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      <div *ngIf=\"row.invoiceType==='Project'; else order\">\r\n        <div [matTooltip]=\"projectLookup[row?.projectId].name\"\r\n             [matTooltipShowDelay]=\"1000\">{{projectLookup[row?.projectId]?.name | truncate:30}}</div>\r\n      </div>\r\n      <ng-template #order>\r\n        <div> {{row?.billingStartDate.toDate() | date:\"shortDate\"}}</div>\r\n      </ng-template>\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Invoice Number -->\r\n  <ng-container matColumnDef=\"item\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n=\"@@sk-invoiceItem\">Invoice Item</th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      <div *ngIf=\"row?.invoiceType === 'Material'\">\r\n        {{ productLookup[row?.productId]?.productName }}\r\n      </div>\r\n      <div *ngIf=\"row?.invoiceType !== 'Material'\">\r\n        {{ serviceLookup[row?.serviceId]?.name }}\r\n      </div>\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Invoice Tax -->\r\n  <ng-container matColumnDef=\"subtotal\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n=\"@@sk-subTotal\">Subtotal</th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      {{ row?.invoiceSubtotal | currency }}\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Invoice Tax -->\r\n  <ng-container matColumnDef=\"tax\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n=\"@@sk-tax\">Tax</th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      {{ row?.salesTaxRate?.rate}}<span>% -</span>\r\n      {{ row?.invoiceTaxAmount | currency }}\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Invoice Total -->\r\n  <ng-container matColumnDef=\"total\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n=\"@@sk-total\">Total</th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      {{ row?.invoiceTotal | currency }}\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Edit Column -->\r\n  <ng-container matColumnDef=\"edit\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      <button mat-icon-button matTooltip=\"Edit invoice item\"\r\n              i18n-matTooltip=\"@@sk-editInvoiceItem\"\r\n              (click)=\"onEditItem(row)\" matTooltipShowDelay=\"1000\" matTooltipPosition=\"right\">\r\n        <mat-icon color=\"primary\">edit</mat-icon>\r\n      </button>\r\n    </td>\r\n  </ng-container>\r\n\r\n  <!-- Delete Column -->\r\n  <ng-container matColumnDef=\"delete\">\r\n    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>\r\n    <td mat-cell *matCellDef=\"let row\">\r\n      <button mat-icon-button matTooltip=\"Delete invoice item\"\r\n              i18n=\"@@sk-deleteInvoiceItem\"\r\n              (click)=\"onDeleteItem(row)\" matTooltipShowDelay=\"1000\"\r\n              matTooltipPosition=\"right\">\r\n        <mat-icon color=\"primary\">delete</mat-icon>\r\n      </button>\r\n    </td>\r\n  </ng-container>\r\n\r\n  <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n  <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\">\r\n  </tr>\r\n\r\n</table>\r\n\r\n<mat-paginator\r\n  [hidden]=\"!dataSource?.data.length\"\r\n  #paginator\r\n  [length]=\"dataSource?.data.length\"\r\n  [pageIndex]=\"0\"\r\n  [pageSize]=\"10\"\r\n  [pageSizeOptions]=\"[10,25,50]\">\r\n</mat-paginator>\r\n");

/***/ }),

/***/ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.html":
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.html ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div mat-dialog-title fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\r\n  <h1 class=\"mat-h1\">Edit Invoice Item</h1>\r\n  <button\r\n    mat-icon-button\r\n    matTooltip=\"Return to Invoice Dashboard\"\r\n    matTooltipShowDelay=\"1000\"\r\n    (click)=\"onCancel()\"\r\n    color=\"primary\"\r\n  >\r\n    <mat-icon color=\"primary\">cancel</mat-icon>\r\n  </button>\r\n</div>\r\n<form *ngIf=\"onReady\" novalidate class=\"sk-form\" [formGroup]=\"invoiceForm\" (ngSubmit)=\"onSubmit()\" fxLayout=\"column\">\r\n\r\n  <div *ngIf=\"!editMode\">\r\n  <mat-form-field ngClass.gt-sm=\"input-50-field\" ngClass.lt-md=\"input-100-field\" appearance=\"outline\" floatLabel=\"never\">\r\n    <mat-label>Project</mat-label>\r\n    <input matInput required [matAutocomplete]=\"projectAuto\" formControlName=\"project\" />\r\n\r\n    <mat-autocomplete #projectAuto=\"matAutocomplete\" [displayWith]=\"displayProject\">\r\n      <ng-container *ngIf=\"(filteredProjects | async)?.length; else noOptions\">\r\n        <mat-option *ngFor=\"let project of (filteredProjects | async)\" [value]=\"project\">\r\n          {{ project?.name }}\r\n        </mat-option>\r\n      </ng-container>\r\n      <ng-template #noOptions>\r\n        <mat-option [value]=\"defaultValue\" class=\"no-data\">\r\n          <span i18n=\"@@sk-noSelectionsFound\" *ngIf=\"invoiceForm.get('project').value\">No Selections Found</span>\r\n        </mat-option>\r\n      </ng-template>\r\n    </mat-autocomplete>\r\n\r\n    <mat-error *ngIf=\"invoiceForm.get('project').hasError('required')\">Please choose a\r\n      project\r\n    </mat-error>\r\n  </mat-form-field>\r\n  </div>\r\n  <div *ngIf=\"!editMode\" fxLayout=\"row\" fxLayoutAlign=\"flex-start center\" fxLayoutGap=\"10px\">\r\n    <mat-form-field ngClass.gt-sm=\"input-75-field\" ngClass.lt-md=\"input-100-field\" appearance=\"outline\"\r\n      floatLabel=\"never\">\r\n    <mat-label>Invoice Item Date</mat-label>\r\n    <input cdkFocusInitial matInput [matDatepicker]=\"invoiceDate\" required\r\n      formControlName=\"invoiceDate\" />\r\n      <mat-datepicker-toggle matSuffix [for]=\"invoiceDate\"></mat-datepicker-toggle>\r\n      <mat-datepicker #invoiceDate></mat-datepicker>\r\n      <mat-error i18n=\"@@sk-requiredField\" *ngIf=\"invoiceForm.get('invoiceDate').hasError('required')\">This field is required\r\n      </mat-error>\r\n    </mat-form-field>\r\n  </div>\r\n  <div *ngIf=\"!editMode\" class=\"input-60-field\" fxLayout=\"row\" fxLayoutGap=\"10px\" fxLayoutAlign=\"flex-start center\">\r\n    <mat-label>Item Type</mat-label>\r\n    <mat-form-field>\r\n      <mat-select formControlName=\"invoiceType\">\r\n        <mat-option value=\"Project\">Project</mat-option>\r\n        <mat-option value=\"Material\">Material</mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n  </div>\r\n\r\n  <div *ngIf=\"!hourly\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n      <mat-label>Subtotal</mat-label>\r\n      <input matInput class=\"invoice-input\" type=\"text\" formControlName=\"invoiceSubtotal\" required>\r\n      <mat-error i18n=\"@@sk-requiredField\" *ngIf=\"invoiceForm.get('invoiceSubtotal').hasError('required')\">This field is required\r\n      </mat-error>\r\n      </mat-form-field>\r\n  </div>\r\n\r\n  <div *ngIf=\"hourly\">\r\n    <div fxLayout=\"column\">\r\n\r\n      <div fxLayout.gt-sm=\"row\" fxLayoutAlign=\"space-between\" fxLayout.lt-sm=\"column\">\r\n      <div fxLayout=\"row\" ngClass.gt-sm=\"input-50-field\" ngClass.lt-md=\"input-100-field\" fxLayoutAlign=\"start center\">\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n        <mat-label class=\"text-label\">Hourly Rate</mat-label>\r\n        <input matInput class=\"invoice-input\" type=\"text\" formControlName=\"hourlyAmount\" required>\r\n        </mat-form-field>\r\n      </div>\r\n\r\n      <div fxLayout=\"row\" ngClass.gt-sm=\"input-50-field\" ngClass.lt-md=\"input-100-field\" fxLayoutAlign=\"start center\">\r\n        <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n        <mat-label class=\"text-label\">Hours to Bill</mat-label>\r\n        <input matInput class=\"invoice-input\" formControlName=\"hourQuantity\" required>\r\n        </mat-form-field>\r\n      </div>\r\n      </div>\r\n\r\n      <div fxLayout=\"row\" class=\"total-line\" fxLayoutGap=\"10px\" fxLayoutAlign=\"start center\">\r\n        <mat-label class=\"text-label\">Subtotal</mat-label>\r\n        <div>{{invoiceSubtotal | currency }} </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n      <mat-label class=\"text-label\">Sales Tax</mat-label>\r\n      <mat-select formControlName=\"salesTaxRate\" [compareWith]=\"compareTax\" matInput>\r\n        <mat-option *ngFor=\"let taxRate of taxRates | async\" [(value)]=taxRate>\r\n          {{ taxRate.description }}-{{ taxRate.rate }}%\r\n        </mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n  </div>\r\n\r\n  <div *ngIf=\"invoiceType !== 'Material'\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n      <mat-label class=\"text-label\">Service</mat-label>\r\n      <mat-select formControlName=\"service\" [compareWith]=\"compareService\" matInput>\r\n        <mat-option *ngFor=\"let acctService of acctServices\" [(value)]=acctService>\r\n          {{ acctService.name }}\r\n        </mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n  </div>\r\n\r\n  <div *ngIf=\"invoiceType === 'Material'\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\r\n    <mat-form-field appearance=\"outline\" floatLabel=\"never\">\r\n      <mat-label class=\"text-label\">Product</mat-label>\r\n      <mat-select formControlName=\"product\" [compareWith]=\"compareProduct\" matInput>\r\n        <mat-option *ngFor=\"let product of products\" [(value)]=product>\r\n          {{ product.productName }}\r\n        </mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n  </div>\r\n\r\n\r\n  <div fxLayout=\"row\" class=\"total-line\" fxLayoutGap=\"10px\" fxLayoutAlign=\"start center\">\r\n    <div class=\"text-label\">Invoice Item Total</div>\r\n    <div>{{invoiceTotal | currency }} </div>\r\n  </div>\r\n\r\n  <div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n    <button\r\n      mat-button color=\"accent\"\r\n      type=\"button\"\r\n      (click)=\"onCancel()\">Cancel\r\n    </button>\r\n    <button mat-raised-button class=\"save-button\" color=\"primary\" type=\"submit\">\r\n      Save\r\n    </button>\r\n  </div>\r\n</form>\r\n");

/***/ }),

/***/ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.html":
/*!********************************************************************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/raw-loader/dist/cjs.js!./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.html ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<span class=\"cdk-visually-hidden\" #returnDialog i18n=\"@@sk-returnDialog\">Return from dialog</span>\r\n<span class=\"cdk-visually-hidden\" #usrMesg i18n=\"@@sk-userMsg\">User Message</span>\r\n<span class=\"cdk-visually-hidden\" #close i18n=\"@@sk-close\">Close</span>\r\n<ng-container>{{translate(returnDialog.innerHTML, usrMesg.innerHTML, close.innerHTML)}}</ng-container>\r\n\r\n\r\n<div mat-dialog-title fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\r\n  <h1 class=\"mat-h1\">{{ headerText }}</h1>\r\n  <button\r\n    mat-icon-button\r\n    matTooltip=\"toolTipText\"\r\n    i18n-matTooltip=\"@@sk-toolTipText\"\r\n    matTooltipShowDelay=\"1000\"\r\n    (click)=\"onCancel()\"\r\n    color=\"primary\">\r\n    <mat-icon color=\"primary\">cancel</mat-icon>\r\n  </button>\r\n</div>\r\n<p>{{ alertData?.message }}</p>\r\n<div mat-dialog-actions fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n  <button\r\n    *ngFor=\"let dialogButton of dialogButtons\"\r\n    mat-raised-button\r\n    color=\"primary\"\r\n    (click)=\"onButtonClick(dialogButton)\">{{ dialogButton }}</button>\r\n</div>\r\n");

/***/ }),

/***/ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!******************************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\r\n");

/***/ }),

/***/ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/components/invoice-display/invoice-display.component.html":
/*!*********************************************************************************************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/raw-loader/dist/cjs.js!./src/app/components/invoice-display/invoice-display.component.html ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<section *ngIf=\"onReady && gotData\" class=\"sk-overview-container\">\r\n  <div\r\n    class=\"sk-breadcrumb-container\"\r\n    fxLayout=\"row\"\r\n    fxLayoutAlign=\"space-between center\"\r\n  >\r\n    <div\r\n      class=\"sk-breadcrumb-links-row\"\r\n      fxLayout=\"row\"\r\n      fxLayoutGap=\"10px\"\r\n      fxLayoutAlign=\"start\"\r\n    >\r\n      <a routerLink=\"/office\"> <mat-icon>home</mat-icon> </a>\r\n      <mat-icon>chevron_right</mat-icon>\r\n      <a routerLink=\"/office/invoicing/overview\" routerLinkActive=\"active\">Invoicing</a>\r\n      <mat-icon>chevron_right</mat-icon>\r\n      <div>Display</div>\r\n    </div>\r\n    <div class=\"sk-breadcrumb-action-row\" fxLayout=\"row\" fxLayoutAlign=\"end\">\r\n      <button\r\n        mat-icon-button\r\n        [matMenuTriggerFor]=\"invoicemenu\"\r\n        matTooltip=\"Invoice Actions\"\r\n        matTooltipShowDelay=\"1000\"\r\n      >\r\n        <mat-icon color=\"primary\">more_vert</mat-icon>\r\n      </button>\r\n      <mat-menu #invoicemenu=\"matMenu\">\r\n        <button\r\n          mat-menu-item\r\n          matTooltip=\"Pay invoice\"\r\n          matTooltipShowDelay=\"1000\">\r\n          <mat-icon color=\"primary\">attach_money</mat-icon>\r\n          <span>Pay Invoice</span>\r\n        </button>\r\n      </mat-menu>\r\n    </div>\r\n  </div>\r\n\r\n  <mat-toolbar>\r\n    <h1 class=\"mat-h1\">Invoice #{{invoice?.invoiceNumber}}</h1>\r\n  </mat-toolbar>\r\n\r\n  <div fxLayout=\"column\" fxLayoutGap=\"10px\">\r\n\r\n    <div fxLayoutGap=\"10px\" fxLayout.gt-sm=\"row\" fxLayout.lt-md=\"column\">\r\n      <mat-card class=\"sk-dashboard-card\">\r\n        <div fxLayout=\"column\">\r\n\r\n          <!-- Customer Name and Email -->\r\n          <div>Customer</div>\r\n          <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"30px\">\r\n            <h4 class=\"mat-h4\">{{ locationLookup[invoice?.locationId].locationName | truncate:50 }}\r\n            </h4>\r\n            <div fxLayout=\"row\" fxLayoutGap=\"10px\">\r\n              <h4 class=\"mat-h4\">Email: </h4>\r\n              <h4 class=\"mat-h4\">{{ locationLookup[invoice?.locationId].locationEmail }}</h4>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Row with invoice info -->\r\n          <div fxLayout=\"row\" fxLayoutAlign=\"start\" fxLayoutGap=\"50px\">\r\n\r\n            <!-- Address block -->\r\n            <div fxLayout=\"column\">\r\n              <div>Billing Address</div>\r\n              <div fxLayout=\"row\" fxLayoutGap=\"10px\">\r\n                <div>{{ locationLookup[invoice?.locationId].address.street1 }}</div>\r\n                <div>{{ locationLookup[invoice?.locationId].address.street2 }}</div>\r\n              </div>\r\n              <div fxLayout=\"row\" fxLayoutGap=\"10px\">\r\n                <div>{{ locationLookup[invoice?.locationId].address.city }},</div>\r\n                <div>{{ locationLookup[invoice?.locationId].address.state }}</div>\r\n                <div>{{ locationLookup[invoice?.locationId].address.zip }}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Terms -->\r\n            <div fxLayout=\"column\" fxLayoutAlign=\"start center\">\r\n              <div>Terms</div>\r\n              <div class=\"detail-value-capitalize\">{{ invoice?.invoiceTerms.name }}</div>\r\n            </div>\r\n\r\n            <!-- Invoice Date -->\r\n            <div fxLayout=\"column\" fxLayoutAlign=\"start center\">\r\n              <div>Invoice Date</div>\r\n              <div class=\"detail-value-capitalize\">{{ invoice?.invoiceDate.toDate() | date:\"shortDate\" }}</div>\r\n            </div>\r\n\r\n            <!-- Due Date -->\r\n            <div fxLayout=\"column\" fxLayoutAlign=\"start center\">\r\n              <div>Due Date</div>\r\n              <div class=\"detail-value-capitalize\">{{ invoice?.dueDate.toDate() | date:\"shortDate\" }}</div>\r\n            </div>\r\n          </div>\r\n\r\n        <sk-invoice-detail [invoiceId]=invoiceId [allowEdit]=false></sk-invoice-detail>\r\n\r\n        </div>\r\n      </mat-card>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n<!-- ToDo : Server side message should be translated -->\r\n");

/***/ }),

/***/ "../../../node_modules/tslib/tslib.es6.js":
/*!*********************************************************************!*\
  !*** D:/Industrylinq/servicekicker/node_modules/tslib/tslib.es6.js ***!
  \*********************************************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.scss":
/*!***********************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.scss ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHBzL2JhY2tvZmZpY2Uvd2ViLWFwcC9zcmMvYXBwL19vZmZpY2UvaW52b2ljaW5nL2ludm9pY2luZy1vdmVydmlldy9pbnZvaWNpbmctZGFzaGJvYXJkL2ludm9pY2UtZGV0YWlsL2ludm9pY2UtZGV0YWlsLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.ts":
/*!*********************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.ts ***!
  \*********************************************************************************************************************/
/*! exports provided: InvoiceDetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceDetailComponent", function() { return InvoiceDetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/paginator */ "../../../node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/sort */ "../../../node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/table */ "../../../node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var environments_environment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var shared_services_invoice_item_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! shared/services/invoice-item.service */ "./src/app/_shared/services/invoice-item.service.ts");
/* harmony import */ var shared_services_project_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! shared/services/project.service */ "./src/app/_shared/services/project.service.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material */ "../../../node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var shared_dialogs_alert_dialog_alert_dialog_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! shared/dialogs/alert-dialog/alert-dialog.component */ "./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.ts");
/* harmony import */ var _invoiceitem_edit_dialog_invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./invoiceitem-edit-dialog/invoiceitem-edit-dialog.component */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.ts");
/* harmony import */ var shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! shared/services/acct-services.service */ "./src/app/_shared/services/acct-services.service.ts");
/* harmony import */ var shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! shared/services/supplies.service */ "./src/app/_shared/services/supplies.service.ts");















let InvoiceDetailComponent = class InvoiceDetailComponent {
    constructor(dialog, snackBar, projectService, acctServicesService, suppliesService, invoiceItemService) {
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.projectService = projectService;
        this.acctServicesService = acctServicesService;
        this.suppliesService = suppliesService;
        this.invoiceItemService = invoiceItemService;
        this.invoiceAmountChanged = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"];
        this.onReady = false;
        this.gotInvoiceDetail = false;
        this.projectLookup = {};
        this.serviceLookup = {};
        this.productLookup = {};
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"]([]);
        this.displayedColumns = ['project', 'item', 'subtotal', 'tax', 'total', 'edit', 'delete'];
        this.unsubscribe$ = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.filterValue = 'true';
        this.snackbarDeleted = 'Invoice Item has been deleted.';
        this.snackbarSuccess = 'Success';
        this.archiveInvoice = 'Archive Invoice';
        this.cancelTooltip = 'Return to invoice dashboard';
        this.archiveMsg = 'Are you sure you want to delete this invoice item?';
        this.yesButton = 'yes';
        this.noButton = 'no';
    }
    ngOnInit() {
        if (!this.allowEdit) {
            this.displayedColumns = ['project', 'item', 'subtotal', 'tax', 'total'];
        }
        this.getData();
        this.getInvoiceDetail();
    }
    onEditItem(invoiceItem) {
        // Allow user to change the invoice item in a dialog
        // If they change the total of the invoice item, emit an event
        // to the parent component
        const currentTotal = invoiceItem.invoiceTotal;
        const dialogRef = this.dialog.open(_invoiceitem_edit_dialog_invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_12__["InvoiceItemEditDialogComponent"], {
            panelClass: 'invoiceitem-edit-dialog',
            data: invoiceItem
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                const newInvoiceItem = result;
                if (newInvoiceItem.invoiceTotal !== currentTotal) {
                    // If the invoiceitem total changes, adjust the invoice total
                    this.invoiceAmountChanged.emit(newInvoiceItem.invoiceTotal - currentTotal);
                }
                this.invoiceItemService.updateInvoiceItem(newInvoiceItem, newInvoiceItem.id)
                    .subscribe(() => {
                }, error => {
                    if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                        console.error(error);
                    }
                });
            }
        });
    }
    onDeleteItem(invoiceItem) {
        // Show the user a modal to confirm that they want to delete the
        // invoice item, if they do, send an event to the parent component
        const dialogRef = this.dialog.open(shared_dialogs_alert_dialog_alert_dialog_component__WEBPACK_IMPORTED_MODULE_11__["AlertDialogComponent"], {
            data: {
                header: this.archiveInvoice,
                cancelTooltip: this.cancelTooltip,
                message: this.archiveMsg,
                buttons: [this.yesButton, this.noButton]
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'yes' || result === 'ja') {
                this.invoiceAmountChanged.emit(invoiceItem.invoiceTotal * -1);
                this.invoiceItemService.deleteInvoiceItem(invoiceItem.id)
                    .subscribe(() => {
                    this.snackBar.open(this.snackbarDeleted, this.snackbarSuccess, {
                        duration: 5000
                    });
                }, error => {
                    if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                        console.error(error);
                    }
                });
            }
        });
    }
    getInvoiceDetail() {
        this.invoiceItemService.getInvoiceItems(this.invoiceId)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this.unsubscribe$))
            .subscribe(list => {
            if ((list) && (list.length !== 0)) {
                this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"](list);
                setTimeout(() => {
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }, 200);
                this.gotInvoiceDetail = true;
            }
            else {
                this.gotInvoiceDetail = false;
            }
        }, error => {
            if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                console.error(error);
            }
        });
    }
    getData() {
        this.projectService.getProjectSource()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this.unsubscribe$), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(projectData => {
            if (projectData && (Object.keys(projectData).length !== 0)) {
                this.projectLookup = projectData;
            }
            return this.suppliesService.getProductSource();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(productData => {
            if (productData && (Object.keys(productData).length !== 0)) {
                this.productLookup = productData;
            }
            return this.acctServicesService.getServiceSource();
        }))
            .subscribe(serviceData => {
            if (serviceData && (Object.keys(serviceData).length !== 0)) {
                this.serviceLookup = serviceData;
            }
            this.onReady = true;
        }, error => {
            if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                console.error(error);
            }
        });
    }
    translate(invoiceDel, success, archiveInvoice, returnDashboard, shouldDelete, yesText, noText) {
        this.snackbarDeleted = invoiceDel;
        this.snackbarSuccess = success;
        this.archiveInvoice = archiveInvoice;
        this.cancelTooltip = returnDashboard;
        this.archiveMsg = shouldDelete;
        this.yesButton = yesText;
        this.noButton = noText;
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
};
InvoiceDetailComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_10__["MatDialog"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_10__["MatSnackBar"] },
    { type: shared_services_project_service__WEBPACK_IMPORTED_MODULE_9__["ProjectService"] },
    { type: shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_13__["AcctServicesService"] },
    { type: shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_14__["SuppliesService"] },
    { type: shared_services_invoice_item_service__WEBPACK_IMPORTED_MODULE_8__["InvoiceItemService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], InvoiceDetailComponent.prototype, "invoiceId", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Boolean)
], InvoiceDetailComponent.prototype, "allowEdit", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], InvoiceDetailComponent.prototype, "invoiceAmountChanged", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"])
], InvoiceDetailComponent.prototype, "paginator", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_5__["MatSort"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_5__["MatSort"])
], InvoiceDetailComponent.prototype, "sort", void 0);
InvoiceDetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'sk-invoice-detail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./invoice-detail.component.html */ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./invoice-detail.component.scss */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material__WEBPACK_IMPORTED_MODULE_10__["MatDialog"],
        _angular_material__WEBPACK_IMPORTED_MODULE_10__["MatSnackBar"],
        shared_services_project_service__WEBPACK_IMPORTED_MODULE_9__["ProjectService"],
        shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_13__["AcctServicesService"],
        shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_14__["SuppliesService"],
        shared_services_invoice_item_service__WEBPACK_IMPORTED_MODULE_8__["InvoiceItemService"]])
], InvoiceDetailComponent);



/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.module.ts":
/*!******************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.module.ts ***!
  \******************************************************************************************************************/
/*! exports provided: InvoiceDetailModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceDetailModule", function() { return InvoiceDetailModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _invoice_detail_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./invoice-detail.component */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.component.ts");
/* harmony import */ var _invoiceitem_edit_dialog_invoiceitem_edit_dialog_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./invoiceitem-edit-dialog/invoiceitem-edit-dialog.module */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.module.ts");
/* harmony import */ var _sk_custom_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @sk/custom-material */ "../../../libs/custom-material/src/index.ts");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/flex-layout */ "../../../node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_mask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-mask */ "../../../node_modules/ngx-mask/fesm2015/ngx-mask.js");
/* harmony import */ var shared_pipes_truncationPipe_truncationPipe_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! shared/pipes/truncationPipe/truncationPipe.module */ "./src/app/_shared/pipes/truncationPipe/truncationPipe.module.ts");










let InvoiceDetailModule = class InvoiceDetailModule {
};
InvoiceDetailModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_invoice_detail_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceDetailComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _sk_custom_material__WEBPACK_IMPORTED_MODULE_5__["CustomMaterialModule"],
            ngx_mask__WEBPACK_IMPORTED_MODULE_8__["NgxMaskModule"].forRoot(),
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_6__["FlexLayoutModule"],
            _invoiceitem_edit_dialog_invoiceitem_edit_dialog_module__WEBPACK_IMPORTED_MODULE_4__["InvoiceItemEditDialogModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_7__["RouterModule"],
            shared_pipes_truncationPipe_truncationPipe_module__WEBPACK_IMPORTED_MODULE_9__["TruncationPipeModule"],
        ],
        providers: [],
        exports: [_invoice_detail_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceDetailComponent"]]
    })
], InvoiceDetailModule);



/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.scss":
/*!********************************************************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.scss ***!
  \********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".total-line {\n  margin: 0px 0px 24px 0px; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcHMvYmFja29mZmljZS93ZWItYXBwL3NyYy9hcHAvX29mZmljZS9pbnZvaWNpbmcvaW52b2ljaW5nLW92ZXJ2aWV3L2ludm9pY2luZy1kYXNoYm9hcmQvaW52b2ljZS1kZXRhaWwvaW52b2ljZWl0ZW0tZWRpdC1kaWFsb2cvRDpcXEluZHVzdHJ5bGlucVxcc2VydmljZWtpY2tlci9hcHBzXFxiYWNrb2ZmaWNlXFx3ZWItYXBwXFxzcmNcXGFwcFxcX29mZmljZVxcaW52b2ljaW5nXFxpbnZvaWNpbmctb3ZlcnZpZXdcXGludm9pY2luZy1kYXNoYm9hcmRcXGludm9pY2UtZGV0YWlsXFxpbnZvaWNlaXRlbS1lZGl0LWRpYWxvZ1xcaW52b2ljZWl0ZW0tZWRpdC1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSx3QkFBd0IsRUFBQSIsImZpbGUiOiJhcHBzL2JhY2tvZmZpY2Uvd2ViLWFwcC9zcmMvYXBwL19vZmZpY2UvaW52b2ljaW5nL2ludm9pY2luZy1vdmVydmlldy9pbnZvaWNpbmctZGFzaGJvYXJkL2ludm9pY2UtZGV0YWlsL2ludm9pY2VpdGVtLWVkaXQtZGlhbG9nL2ludm9pY2VpdGVtLWVkaXQtZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRvdGFsLWxpbmUge1xyXG4gIG1hcmdpbjogMHB4IDBweCAyNHB4IDBweDtcclxufVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.ts":
/*!******************************************************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.ts ***!
  \******************************************************************************************************************************************************/
/*! exports provided: InvoiceItemEditDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceItemEditDialogComponent", function() { return InvoiceItemEditDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "../../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "../../../node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var shared_validators_autocomplete_validator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! shared/validators/autocomplete-validator */ "./src/app/_shared/validators/autocomplete-validator.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/dialog */ "../../../node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material */ "../../../node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var shared_services_tax_rate_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! shared/services/tax-rate.service */ "./src/app/_shared/services/tax-rate.service.ts");
/* harmony import */ var shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! shared/services/acct-services.service */ "./src/app/_shared/services/acct-services.service.ts");
/* harmony import */ var shared_services_project_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! shared/services/project.service */ "./src/app/_shared/services/project.service.ts");
/* harmony import */ var firebase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! firebase */ "../../../node_modules/firebase/dist/index.cjs.js");
/* harmony import */ var firebase__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(firebase__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! shared/services/supplies.service */ "./src/app/_shared/services/supplies.service.ts");
/* harmony import */ var environments_environment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! environments/environment */ "./src/environments/environment.ts");














let InvoiceItemEditDialogComponent = class InvoiceItemEditDialogComponent {
    constructor(fb, snackBar, taxRatesService, acctServicesService, suppliesService, projectService, dialogRef, data) {
        this.fb = fb;
        this.snackBar = snackBar;
        this.taxRatesService = taxRatesService;
        this.acctServicesService = acctServicesService;
        this.suppliesService = suppliesService;
        this.projectService = projectService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.invoiceItemId = '';
        this.invoiceSubtotal = 0;
        this.invoiceTotal = 0;
        this.salesTaxAmount = 0;
        this.invoiceType = 'Project';
        this.hourly = false;
        this.projectLookup = {};
        this.editMode = false;
        this.onReady = false;
        this.defaultValue = null;
    }
    ngOnInit() {
        this.getData();
        this.editMode = (this.data.id) ? true : false;
        this.invoiceItem = this.data;
        this.taxRates = this.taxRatesService.getTaxRates();
        this.initForm();
        if (this.editMode) {
            this.patchForm();
        }
        else {
            this.newItemControls();
        }
        // I dont think I will need to do this this.calculateAmounts();
    }
    compareTax(o1, o2) {
        return o1.description === o2.description;
    }
    compareService(o1, o2) {
        return o1.name === o2.name;
    }
    compareProduct(o1, o2) {
        return o1.productName === o2.productName;
    }
    newItemControls() {
        // If this is a brand new invoice item, you need to let the user enter the project,
        // Need to get the project, invoiceType, hourly/flat fee, billing date,
        this.invoiceForm.addControl('project', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, shared_validators_autocomplete_validator__WEBPACK_IMPORTED_MODULE_5__["AutoCompleteValidator"].bind(this)]));
        this.filterProjects();
        this.invoiceForm.addControl('invoiceType', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]('Project'));
        this.invoiceForm.addControl('invoiceDate', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_3__(), [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]));
        this.invoiceForm.addControl('service', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](null, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
        this.onInvoiceTypeChanges();
    }
    patchForm() {
        this.salesTaxAmount = this.invoiceItem.invoiceTaxAmount;
        this.invoiceSubtotal = this.invoiceItem.invoiceSubtotal;
        this.invoiceTotal = this.invoiceItem.invoiceTotal;
        this.invoiceType = this.invoiceItem.invoiceType;
        if (this.invoiceItem.invoiceType === 'Order') {
            this.hourly = (this.invoiceItem.hourlyRate !== null) ? true : false;
        }
        if (this.hourly) {
            this.invoiceForm.removeControl('invoiceSubtotal');
            this.invoiceForm.addControl('hourQuantity', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](this.invoiceItem.hourQuantity, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
            this.invoiceForm.addControl('hourlyAmount', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](this.invoiceItem.hourlyRate.toFixed(2), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
        }
        this.invoiceForm.patchValue({
            salesTaxRate: this.invoiceItem.salesTaxRate,
            invoiceSubtotal: this.invoiceItem.invoiceSubtotal.toFixed(2)
        });
        let service;
        let product;
        if (this.invoiceType === 'Material') {
            product = this.products.find(x => x.id === this.invoiceItem.productId);
            this.invoiceForm.addControl('product', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](product, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
        }
        else {
            service = this.acctServices.find(x => x.id === this.invoiceItem.serviceId);
            this.invoiceForm.addControl('service', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](service, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
        }
    }
    notZeroValidator(control) {
        // Ensure that if the user is supposed to enter a value that it is not
        // less than 0
        if (control.value) {
            if (parseFloat(control.value) <= 0) {
                return { required: true };
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
    initForm() {
        this.invoiceForm = this.fb.group({
            salesTaxRate: [this.invoiceItem.salesTaxRate, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            invoiceSubtotal: ['0.00', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, this.notZeroValidator.bind(this)]]
        });
        this.onValueChanges();
    }
    onValueChanges() {
        this.invoiceForm.valueChanges
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["debounceTime"])(500), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["distinctUntilChanged"])())
            .subscribe(() => {
            this.calculateAmounts();
        });
    }
    onInvoiceTypeChanges() {
        this.invoiceForm.get('invoiceType').valueChanges
            .subscribe(val => {
            this.invoiceType = val;
            if (this.invoiceType === 'Material') {
                this.invoiceForm.removeControl('service');
                this.invoiceForm.addControl('product', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](null, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
            }
            else {
                this.invoiceForm.removeControl('product');
                this.invoiceForm.addControl('service', new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](null, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required));
            }
        });
    }
    calculateAmounts() {
        // If the user changes a field, recalculate everything and patch the form
        if (this.invoiceForm.value.salesTaxRate !== null) {
            this.invoiceSubtotal =
                (!this.hourly) ?
                    parseFloat(this.invoiceForm.value.invoiceSubtotal) :
                    parseFloat(this.invoiceForm.value.hourQuantity) * parseFloat(this.invoiceForm.value.hourlyAmount);
            this.salesTaxAmount = this.invoiceSubtotal * (this.invoiceForm.value.salesTaxRate.rate / 100);
            this.invoiceTotal = this.invoiceSubtotal + (this.invoiceSubtotal * (this.invoiceForm.value.salesTaxRate.rate / 100));
            if (this.hourly) {
                this.invoiceForm.patchValue({
                    invoiceSubtotal: this.invoiceSubtotal.toFixed(2)
                });
            }
        }
    }
    onSubmit() {
        if (this.invoiceForm.invalid || (this.invoiceTotal <= 0)) {
            this.snackBar.open('Please fill required fields', 'Error', {
                duration: 5000
            });
            return;
        }
        if (this.editMode) {
            const invoiceItem = {
                locationId: this.invoiceItem.locationId,
                projectId: this.invoiceItem.projectId,
                orderId: this.invoiceItem.orderId,
                invoiceType: this.invoiceItem.invoiceType,
                hourQuantity: (this.hourly) ? parseFloat(this.invoiceForm.value.hourQuantity) : null,
                hourlyRate: (this.hourly) ? parseFloat(this.invoiceForm.value.hourlyAmount) : null,
                salesTaxRate: this.invoiceForm.value.salesTaxRate,
                serviceId: (this.invoiceType !== 'Material') ? this.invoiceForm.value.service.id : null,
                productId: (this.invoiceType === 'Material') ? this.invoiceForm.value.product.id : null,
                invoiceTaxAmount: this.salesTaxAmount,
                invoiceTotal: this.invoiceTotal,
                invoiceSubtotal: this.invoiceSubtotal,
                billingStartDate: this.invoiceItem.billingStartDate,
                billingEndDate: this.invoiceItem.billingEndDate,
                invoiceId: this.invoiceItem.invoiceId,
                status: this.invoiceItem.status,
                id: this.invoiceItem.id,
                exists: this.invoiceItem.exists
            };
            this.dialogRef.close(invoiceItem);
        }
        else {
            const invoiceItem = {
                locationId: this.invoiceItem.locationId,
                projectId: this.invoiceForm.value.project.id,
                orderId: null,
                invoiceType: this.invoiceForm.value.invoiceType,
                hourQuantity: null,
                hourlyRate: null,
                salesTaxRate: this.invoiceForm.value.salesTaxRate,
                serviceId: (this.invoiceType !== 'Material') ? this.invoiceForm.value.service.id : null,
                productId: (this.invoiceType === 'Material') ? this.invoiceForm.value.product.id : null,
                invoiceTaxAmount: this.salesTaxAmount,
                invoiceTotal: this.invoiceTotal,
                invoiceSubtotal: this.invoiceSubtotal,
                billingStartDate: firebase__WEBPACK_IMPORTED_MODULE_11__["firestore"].Timestamp.fromDate(this.invoiceForm.value.invoiceDate.toDate()),
                billingEndDate: firebase__WEBPACK_IMPORTED_MODULE_11__["firestore"].Timestamp.fromDate(this.invoiceForm.value.invoiceDate.toDate()),
                invoiceId: this.invoiceItem.invoiceId,
                status: 'active'
            };
            this.dialogRef.close(invoiceItem);
        }
    }
    onCancel() {
        this.dialogRef.close();
    }
    filterProjects() {
        this.filteredProjects = this.invoiceForm.get('project').valueChanges
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["startWith"])(''), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(value => typeof value === 'string' ? value : value.name), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(name => name ? this._filteredProjects(name) : this.projects.slice()));
    }
    _filteredProjects(value) {
        const filterValue = value.toLowerCase();
        return this.projects.filter(project => project.name.toLowerCase().indexOf(filterValue) === 0);
    }
    displayProject(project) {
        return project ? project.name : undefined;
    }
    // Get the lists of services and products for the selects
    getData() {
        this.acctServicesService.getServiceSource()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])(data => {
            if (data && (Object.keys(data).length !== 0)) {
                this.acctServices = this.acctServicesService.getServiceList();
            }
            return this.suppliesService.getProductSource();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])(productData => {
            if (productData && (Object.keys(productData).length !== 0)) {
                this.products = this.suppliesService.getProductList();
            }
            return this.projectService.getProjectSource();
        }))
            .subscribe(projectData => {
            if (projectData && (Object.keys(projectData).length !== 0)) {
                this.projectLookup = projectData;
                this.projects = this.projectService.getProjectList();
                this.onReady = true;
            }
        }, error => {
            if (!environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].production) {
                console.log('error getting staff and locations' + error);
            }
        });
    }
    ngOnDestroy() {
    }
};
InvoiceItemEditDialogComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: shared_services_tax_rate_service__WEBPACK_IMPORTED_MODULE_8__["TaxRatesService"] },
    { type: shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_9__["AcctServicesService"] },
    { type: shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_12__["SuppliesService"] },
    { type: shared_services_project_service__WEBPACK_IMPORTED_MODULE_10__["ProjectService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MAT_DIALOG_DATA"],] }] }
];
InvoiceItemEditDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'sk-invoiceitem-edit-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./invoiceitem-edit-dialog.component.html */ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./invoiceitem-edit-dialog.component.scss */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](7, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _angular_material__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        shared_services_tax_rate_service__WEBPACK_IMPORTED_MODULE_8__["TaxRatesService"],
        shared_services_acct_services_service__WEBPACK_IMPORTED_MODULE_9__["AcctServicesService"],
        shared_services_supplies_service__WEBPACK_IMPORTED_MODULE_12__["SuppliesService"],
        shared_services_project_service__WEBPACK_IMPORTED_MODULE_10__["ProjectService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialogRef"], Object])
], InvoiceItemEditDialogComponent);



/***/ }),

/***/ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.module.ts":
/*!***************************************************************************************************************************************************!*\
  !*** ./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.module.ts ***!
  \***************************************************************************************************************************************************/
/*! exports provided: InvoiceItemEditDialogModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceItemEditDialogModule", function() { return InvoiceItemEditDialogModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./invoiceitem-edit-dialog.component */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoiceitem-edit-dialog/invoiceitem-edit-dialog.component.ts");
/* harmony import */ var _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @sk/custom-material */ "../../../libs/custom-material/src/index.ts");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/flex-layout */ "../../../node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "../../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_mask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-mask */ "../../../node_modules/ngx-mask/fesm2015/ngx-mask.js");









let InvoiceItemEditDialogModule = class InvoiceItemEditDialogModule {
};
InvoiceItemEditDialogModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceItemEditDialogComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_7__["ReactiveFormsModule"],
            _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__["CustomMaterialModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__["FlexLayoutModule"],
            ngx_mask__WEBPACK_IMPORTED_MODULE_8__["NgxMaskModule"].forRoot(),
            _angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"]
        ],
        providers: [],
        entryComponents: [_invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceItemEditDialogComponent"]],
        exports: [_invoiceitem_edit_dialog_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceItemEditDialogComponent"]]
    })
], InvoiceItemEditDialogModule);



/***/ }),

/***/ "./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.ts ***!
  \************************************************************************/
/*! exports provided: AlertDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertDialogComponent", function() { return AlertDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "../../../node_modules/@angular/material/esm2015/dialog.js");



let AlertDialogComponent = class AlertDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.toolTipText = '';
        this.headerText = '';
        this.dialogButtons = [];
        this.dialogMessage = "Return from dialog";
        this.userMessage = "User Message";
        this.closeMessage = 'close';
    }
    ngOnInit() {
        this.alertData = this.data;
        this.toolTipText = (this.alertData.cancelTooltip) ? this.alertData.cancelTooltip : this.dialogMessage;
        this.headerText = (this.alertData.header) ? this.alertData.header : this.userMessage;
        if (!this.alertData.buttons || !this.alertData.buttons.length) {
            this.dialogButtons.push(this.closeMessage);
        }
        else {
            this.dialogButtons = this.alertData.buttons.map(x => {
                return x;
            });
        }
    }
    onButtonClick(buttonText) {
        this.dialogRef.close(buttonText);
    }
    onCancel() {
        this.dialogRef.close();
    }
    translate(returnDialog, usrMesg, close) {
        this.dialogMessage = returnDialog;
        this.userMessage = usrMesg;
        this.closeMessage = close;
    }
};
AlertDialogComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
AlertDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'sk-alert-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./alert-dialog.component.html */ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.html")).default,
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object])
], AlertDialogComponent);



/***/ }),

/***/ "./src/app/_shared/dialogs/alert-dialog/alert-dialog.module.ts":
/*!*********************************************************************!*\
  !*** ./src/app/_shared/dialogs/alert-dialog/alert-dialog.module.ts ***!
  \*********************************************************************/
/*! exports provided: AlertDialogModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertDialogModule", function() { return AlertDialogModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _alert_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./alert-dialog.component */ "./src/app/_shared/dialogs/alert-dialog/alert-dialog.component.ts");
/* harmony import */ var _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @sk/custom-material */ "../../../libs/custom-material/src/index.ts");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/flex-layout */ "../../../node_modules/@angular/flex-layout/esm2015/flex-layout.js");






let AlertDialogModule = class AlertDialogModule {
};
AlertDialogModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_alert_dialog_component__WEBPACK_IMPORTED_MODULE_3__["AlertDialogComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__["CustomMaterialModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__["FlexLayoutModule"]
        ],
        providers: [],
        entryComponents: [_alert_dialog_component__WEBPACK_IMPORTED_MODULE_3__["AlertDialogComponent"]],
        exports: [_alert_dialog_component__WEBPACK_IMPORTED_MODULE_3__["AlertDialogComponent"]]
    })
], AlertDialogModule);



/***/ }),

/***/ "./src/app/_shared/guards/auth.guard.ts":
/*!**********************************************!*\
  !*** ./src/app/_shared/guards/auth.guard.ts ***!
  \**********************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "../../../node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var shared_services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! shared/services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "../../../node_modules/@angular/material/esm2015/snack-bar.js");







let AuthGuard = class AuthGuard {
    constructor(authService, snackBar, storageService, router) {
        this.authService = authService;
        this.snackBar = snackBar;
        this.storageService = storageService;
        this.router = router;
    }
    canActivate(next, state) {
        return this.authService.user
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(user => {
            if (!user) {
                this.router.navigateByUrl('login');
                return false;
            }
            else {
                const userRole = this.storageService.getStorage('role');
                // ToDo: Remove this before release
                if (!userRole) {
                    this.snackBar
                        .open('Access Denied', 'Roll not available yet... ', {
                        duration: 3000,
                    });
                }
                if ((userRole === 'technician') || (userRole === 'contractor')) {
                    this.router.navigateByUrl('no-access');
                    return false;
                }
                if ((userRole === 'contact')) {
                    // ToDo: This need to route to client section
                    this.router.navigateByUrl('client');
                    return false;
                }
                if ((userRole !== 'admin') && (userRole !== 'manager')) {
                    //ToDo: translate this snackbar message: might have to do manually since no html file here.
                    this.snackBar
                        .open('Access Denied', 'You must be an admin to login to this app', {
                        duration: 3000,
                    });
                    this.router.navigateByUrl('login');
                    return false;
                }
            }
            return true;
        }));
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: shared_services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        shared_services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], AuthGuard);



/***/ }),

/***/ "./src/app/_shared/guards/overview-guard.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/_shared/guards/overview-guard.service.ts ***!
  \**********************************************************/
/*! exports provided: QueryParamsGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryParamsGuard", function() { return QueryParamsGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");


let QueryParamsGuard = class QueryParamsGuard {
    constructor() { }
    canActivate(route, state) {
        if (route.queryParams) {
            return true;
        }
        return false;
    }
};
QueryParamsGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], QueryParamsGuard);



/***/ }),

/***/ "./src/app/_shared/guards/sign-out.guard.ts":
/*!**************************************************!*\
  !*** ./src/app/_shared/guards/sign-out.guard.ts ***!
  \**************************************************/
/*! exports provided: SignOutGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignOutGuard", function() { return SignOutGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "../../../node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");






let SignOutGuard = class SignOutGuard {
    constructor(authService, storageService, router) {
        this.authService = authService;
        this.storageService = storageService;
        this.router = router;
    }
    canActivate(next, state) {
        return this.authService.user
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(user => {
            if (!user) {
                this.router.navigateByUrl('login')
                    .then(() => window.location.reload());
                return false;
            }
            if (user) {
                this.authService.auth.signOut()
                    .then(() => {
                    localStorage.clear();
                    this.storageService.clearStorage();
                    return this.router.navigateByUrl('login');
                })
                    .then(() => {
                    window.location.reload();
                    return false;
                });
            }
        }));
    }
};
SignOutGuard.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
SignOutGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], SignOutGuard);



/***/ }),

/***/ "./src/app/_shared/http-interceptors/authentication.interceptor.ts":
/*!*************************************************************************!*\
  !*** ./src/app/_shared/http-interceptors/authentication.interceptor.ts ***!
  \*************************************************************************/
/*! exports provided: HttpsAuthenticationInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpsAuthenticationInterceptor", function() { return HttpsAuthenticationInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "../../../node_modules/@angular/fire/auth/es2015/index.js");




let HttpsAuthenticationInterceptor = class HttpsAuthenticationInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(req, next) {
        return this.authenticationService.idToken
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["switchMap"])(token => {
            let copiedRequest = req.clone({
                setHeaders: {
                    'Accept': `application/json`,
                    'Content-Type': `application/json`
                }
            });
            if (token) {
                copiedRequest = req.clone({
                    setHeaders: {
                        'Accept': `application/json`,
                        'Content-Type': `application/json`,
                        'Authorization': 'Bearer ' + token
                    }
                });
            }
            return next.handle(copiedRequest);
        }));
    }
};
HttpsAuthenticationInterceptor.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] }
];
HttpsAuthenticationInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"]])
], HttpsAuthenticationInterceptor);



/***/ }),

/***/ "./src/app/_shared/http-interceptors/index.ts":
/*!****************************************************!*\
  !*** ./src/app/_shared/http-interceptors/index.ts ***!
  \****************************************************/
/*! exports provided: httpInterceptorProviders */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "httpInterceptorProviders", function() { return httpInterceptorProviders; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "../../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _authentication_interceptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./authentication.interceptor */ "./src/app/_shared/http-interceptors/authentication.interceptor.ts");

/* "Barrel" of Http Interceptors */


/** Http interceptor providers in outside-in order */
const httpInterceptorProviders = [
    { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HTTP_INTERCEPTORS"], useClass: _authentication_interceptor__WEBPACK_IMPORTED_MODULE_2__["HttpsAuthenticationInterceptor"], multi: true },
];


/***/ }),

/***/ "./src/app/_shared/pipes/truncationPipe/truncationPipe.module.ts":
/*!***********************************************************************!*\
  !*** ./src/app/_shared/pipes/truncationPipe/truncationPipe.module.ts ***!
  \***********************************************************************/
/*! exports provided: TruncationPipeModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruncationPipeModule", function() { return TruncationPipeModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var shared_pipes_truncationPipe_truncationPipe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! shared/pipes/truncationPipe/truncationPipe */ "./src/app/_shared/pipes/truncationPipe/truncationPipe.ts");



let TruncationPipeModule = class TruncationPipeModule {
};
TruncationPipeModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [shared_pipes_truncationPipe_truncationPipe__WEBPACK_IMPORTED_MODULE_2__["TruncationPipe"]],
        imports: [],
        exports: [shared_pipes_truncationPipe_truncationPipe__WEBPACK_IMPORTED_MODULE_2__["TruncationPipe"]],
        providers: [shared_pipes_truncationPipe_truncationPipe__WEBPACK_IMPORTED_MODULE_2__["TruncationPipe"]]
    })
], TruncationPipeModule);



/***/ }),

/***/ "./src/app/_shared/pipes/truncationPipe/truncationPipe.ts":
/*!****************************************************************!*\
  !*** ./src/app/_shared/pipes/truncationPipe/truncationPipe.ts ***!
  \****************************************************************/
/*! exports provided: TruncationPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruncationPipe", function() { return TruncationPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");


let TruncationPipe = class TruncationPipe {
    transform(value, amt) {
        if (!value || !value.length) {
            return;
        }
        let truncVal = value;
        if (value && value.length > amt) {
            amt = amt - 2;
            truncVal = value.slice(0, amt) + '..';
        }
        return truncVal;
    }
};
TruncationPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({ name: 'truncate' })
], TruncationPipe);



/***/ }),

/***/ "./src/app/_shared/services/acct-services.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/_shared/services/acct-services.service.ts ***!
  \***********************************************************/
/*! exports provided: AcctServicesService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcctServicesService", function() { return AcctServicesService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");







let AcctServicesService = class AcctServicesService {
    constructor(firestoreService, storageService) {
        this.firestoreService = firestoreService;
        this.storageService = storageService;
        this.lookupSource = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]({});
        this.serviceLookup = this.lookupSource.asObservable();
        this.serviceDictionary = {};
    }
    /**
     * Returns all accounting services for an Organization - used to populate the services
     * select
     */
    getServices(limit) {
        const organizationId = this.storageService.getOrganizationId();
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('services', ref => {
            let query = ref;
            query = query.orderBy('name', 'asc');
            if (limit) {
                query = query.limit(limit);
            }
            return query;
        }).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(list => {
            if (list.length !== 0) {
                this.buildServiceLookup(list);
                this.services = list;
                return list;
            }
            return null;
        }));
    }
    addService(acctService) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('services').add(acctService))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newService = Object.assign({ id, exists }, acctService);
            return newService;
        }));
    }
    deleteService(serviceId) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('services').doc(serviceId).delete())
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const idx = this.services.findIndex(x => x.id === serviceId);
            if (idx !== -1) {
                this.services.splice(idx, 1);
            }
            if (this.serviceDictionary.hasOwnProperty(serviceId)) {
                delete this.serviceDictionary[serviceId];
            }
            this.lookupSource.next(this.serviceDictionary);
            return res;
        }));
    }
    getServiceSource() {
        return this.lookupSource
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(data => {
            if (Object.keys(data).length === 0) {
                this.getServices()
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe();
            }
            return data;
        }));
    }
    buildServiceLookup(list) {
        const lookup = {};
        list.forEach(x => {
            lookup[x.id] = x;
        });
        this.serviceDictionary = lookup;
        this.lookupSource.next(lookup);
    }
    getServiceList() {
        if (this.services) {
            return this.services.slice();
        }
        else {
            return null;
        }
    }
    clearData() {
        this.lookupSource.next({});
        this.services = [];
    }
};
AcctServicesService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"] }
];
AcctServicesService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"]])
], AcctServicesService);



/***/ }),

/***/ "./src/app/_shared/services/invoice-item.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/_shared/services/invoice-item.service.ts ***!
  \**********************************************************/
/*! exports provided: InvoiceItemService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceItemService", function() { return InvoiceItemService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");






let InvoiceItemService = class InvoiceItemService {
    constructor(firestoreService, storageService) {
        this.firestoreService = firestoreService;
        this.storageService = storageService;
    }
    getInvoiceItems(invoiceId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('invoice-items', ref => ref
            .where('invoiceId', '==', invoiceId)).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            const exists = a.payload.doc.exists;
            return Object.assign({ id, exists }, data);
        })));
    }
    getInvoiceItemsByOrderId(orderId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('invoice-items', ref => ref
            .where('orderId', '==', orderId)).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            const exists = a.payload.doc.exists;
            return Object.assign({ id, exists }, data);
        })));
    }
    addInvoiceItem(invoiceItem) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoice-items').add(invoiceItem)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newInvoiceItem = Object.assign({ id, exists }, invoiceItem);
            return newInvoiceItem;
        }));
    }
    updateInvoiceItem(invoiceItem, invoiceItemId) {
        const organizationId = this.storageService.getStorage('organizationId');
        delete invoiceItem.id;
        delete invoiceItem.exists;
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoice-items').doc(invoiceItemId).update(invoiceItem));
    }
    deleteInvoiceItem(invoiceItemId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoice-items').doc(invoiceItemId).delete());
    }
};
InvoiceItemService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__["LocalStorageService"] }
];
InvoiceItemService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__["LocalStorageService"]])
], InvoiceItemService);



/***/ }),

/***/ "./src/app/_shared/services/invoice.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/_shared/services/invoice.service.ts ***!
  \*****************************************************/
/*! exports provided: InvoiceService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceService", function() { return InvoiceService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "../../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");









let InvoiceService = class InvoiceService {
    constructor(http, storageService, firestoreService) {
        this.http = http;
        this.storageService = storageService;
        this.firestoreService = firestoreService;
    }
    getInvoices(status = 'all') {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('invoices', ref => {
            let query = ref;
            query = query.orderBy('dueDate', 'desc');
            if (status !== 'all') {
                query = query.where('status', '==', status);
            }
            return query;
        }).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })));
    }
    getInvoice(id) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('invoices').doc(id).get()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const invoice = res.data();
            invoice.exists = res.exists;
            invoice.id = id;
            return invoice;
        }));
    }
    getInvoiceWithOrganizationId(id, organizationId) {
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('invoices').doc(id).get()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            if (res.exists) {
                const invoice = res.data();
                invoice.exists = res.exists;
                invoice.id = id;
                return invoice;
            }
            else {
                return null;
            }
        }));
    }
    addInvoice(invoice) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_8__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoices').add(invoice)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newInvoice = Object.assign({ id, exists }, invoice);
            return newInvoice;
        }));
    }
    addInvoices(invoices) {
        const organizationId = this.storageService.getStorage('organizationId');
        const observables = invoices.map(invoice => {
            return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_8__["fromPromise"])(this.firestoreService
                .collection('organizations')
                .doc(organizationId)
                .collection('invoices').add(invoice)).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
                const id = res.id;
                const exists = true;
                const newInvoice = Object.assign({ id, exists }, invoice);
                return newInvoice;
            }));
        });
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["forkJoin"])(observables).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["concatAll"])());
    }
    updateInvoice(invoice, invoiceId) {
        const organizationId = this.storageService.getStorage('organizationId');
        delete invoice.id;
        delete invoice.exists;
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_8__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoices').doc(invoiceId).update(invoice));
    }
    deleteInvoice(invoice) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_8__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('invoices').doc(invoice).delete());
    }
    reSendInvoice(invoiceId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.http
            .post(_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].api_url + '/resendInvoice', JSON.stringify({ organizationId, invoiceId }))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            if (res === 'success') {
                return res;
            }
            else {
                if (!_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
                    console.log('Error resending invoice', res);
                }
                return res;
            }
        }));
    }
};
InvoiceService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_7__["LocalStorageService"] },
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] }
];
InvoiceService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_7__["LocalStorageService"],
        _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"]])
], InvoiceService);



/***/ }),

/***/ "./src/app/_shared/services/local-storage.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/_shared/services/local-storage.service.ts ***!
  \***********************************************************/
/*! exports provided: LocalStorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStorageService", function() { return LocalStorageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");


let LocalStorageService = class LocalStorageService {
    constructor() { }
    getStorage(item) {
        return localStorage.getItem(item);
    }
    setStorage(item, value) {
        localStorage.setItem(item, value);
    }
    clearStorage() {
        localStorage.clear();
    }
    getOrganizationId() {
        return localStorage.getItem('organizationId');
    }
};
LocalStorageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], LocalStorageService);



/***/ }),

/***/ "./src/app/_shared/services/location.service.ts":
/*!******************************************************!*\
  !*** ./src/app/_shared/services/location.service.ts ***!
  \******************************************************/
/*! exports provided: LocationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationService", function() { return LocationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");







let LocationService = class LocationService {
    constructor(firestoreService, storageService) {
        this.firestoreService = firestoreService;
        this.storageService = storageService;
        this.lookupSource = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]({});
        this.locationLookup = this.lookupSource.asObservable();
        this.locationDictionary = {};
    }
    /**
     * Returns all locations for an Organization - used to populate the locations
     * select
     */
    // TODO: Remove the second map and build the list in the first one
    getLocations() {
        const organizationId = this.storageService.getOrganizationId();
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('locations').snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            const exists = a.payload.doc.exists;
            return Object.assign({ id, exists }, data);
        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(list => {
            if (list.length > 0) {
                this.buildLocationLookup(list);
                this.locations = list;
                return list;
            }
            return null;
        }));
    }
    getLocationSource() {
        return this.lookupSource
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(data => {
            if (Object.keys(data).length === 0) {
                this.getLocations()
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe();
            }
            return data;
        }));
    }
    buildLocationLookup(list) {
        const lookup = {};
        list.forEach(x => {
            lookup[x.id] = x;
        });
        this.locationDictionary = lookup;
        this.lookupSource.next(lookup);
    }
    getLocationList() {
        if (this.locations) {
            return this.locations.slice();
        }
        else {
            return null;
        }
    }
    clearData() {
        this.lookupSource.next({});
        this.locations = [];
    }
    getLocation(locationId) {
        const organizationId = this.storageService.getOrganizationId();
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('locations').doc(locationId).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(a => {
            const data = a.payload.data();
            const id = a.payload.id;
            const exists = a.payload.exists;
            return Object.assign({ id, exists }, data);
        }));
    }
    addLocation(location) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService.collection('organizations').doc(organizationId)
            .collection('locations').add(location))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newLocation = Object.assign({ id, exists }, location);
            this.locationDictionary[id] = newLocation;
            this.locations.push(newLocation);
            this.lookupSource.next(this.locationDictionary);
            return newLocation;
        }));
    }
    updateLocation(locationData, id) {
        const organizationId = this.storageService.getOrganizationId();
        this.clearData();
        delete locationData.id;
        delete locationData.exists;
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('locations').doc(id).update(locationData))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(() => {
            const exists = true;
            const location = Object.assign({ id, exists }, locationData);
            const idx = this.locations.findIndex(x => x.id === id);
            this.locations[idx] = location;
            this.locationDictionary[id] = location;
            this.lookupSource.next(this.locationDictionary);
            return location;
        }));
    }
};
LocationService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"] }
];
LocationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"]])
], LocationService);



/***/ }),

/***/ "./src/app/_shared/services/project.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/_shared/services/project.service.ts ***!
  \*****************************************************/
/*! exports provided: ProjectService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectService", function() { return ProjectService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");







let ProjectService = class ProjectService {
    constructor(firestoreService, storageService) {
        this.firestoreService = firestoreService;
        this.storageService = storageService;
        this.lookupSource = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]({});
        this.projectLookup = this.lookupSource.asObservable();
        this.projectDictionary = {};
    }
    /**
     * Returns all projects for an Organization, used by the scheduling
     * module
    **/
    getProjects(filterValue = 'all', subscription = 'all') {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('projects', ref => {
            let query = ref;
            query = query.orderBy('name', 'asc');
            if (filterValue !== 'all') {
                query = (filterValue === 'active') ? query.where('active', '==', true) : query.where('active', '==', false);
            }
            if (subscription !== 'all') {
                query = (subscription === 'true') ? query.where('subscription', '==', true) : query.where('subscription', '==', false);
            }
            return query;
        })
            .snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(list => {
            if (list.length !== 0) {
                this.buildProjectLookup(list);
                this.projects = list;
                return list;
            }
        }));
    }
    // This is for the project autocomplete in the invoiceItemEditDialog
    getProjectsLocation(locationId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('projects', ref => {
            let query = ref;
            query = query.orderBy('name', 'asc');
            query = query.where('active', '==', true);
            query = query.where('locationId', '==', locationId);
            return query;
        })
            .snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })));
    }
    buildProjectLookup(list) {
        const lookup = {};
        list.forEach(x => {
            lookup[x.id] = x;
        });
        this.projectDictionary = lookup;
        this.lookupSource.next(lookup);
    }
    getProjectSource() {
        return this.lookupSource
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(data => {
            if (Object.keys(data).length === 0) {
                this.getProjects()
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe();
            }
            return data;
        }));
    }
    getProjectList() {
        return this.projects.slice();
    }
    clearData() {
        this.lookupSource.next({});
        this.projects = [];
    }
    getProject(id) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('projects').doc(id).get()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const project = res.data();
            const exists = res.exists;
            const newProject = Object.assign({ id, exists }, project);
            return newProject;
        }));
    }
    // TODO: If you haven't done a get yet then you won't be able to update the cache
    addProject(project) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService.collection('organizations').doc(organizationId)
            .collection('projects').add(project))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newProject = Object.assign({ id, exists }, project);
            this.projectDictionary[id] = newProject;
            if (this.projects) {
                this.projects.push(newProject);
            }
            this.lookupSource.next(this.projectDictionary);
            return newProject;
        }));
    }
    updateProject(project, projectId) {
        const organizationId = this.storageService.getStorage('organizationId');
        const projectUpdate = Object;
        delete project.id;
        delete project.exists;
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_6__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('projects').doc(projectId).update(project))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(() => {
            const id = projectId;
            const exists = true;
            const newProject = Object.assign({ id, exists }, project);
            this.projectDictionary[id] = newProject;
            if (this.projects) {
                const idx = this.projects.findIndex(x => x.id === projectId);
                this.projects[idx] = newProject;
            }
            this.lookupSource.next(this.projectDictionary);
            return newProject;
        }));
        ;
    }
};
ProjectService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"] }
];
ProjectService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_5__["LocalStorageService"]])
], ProjectService);



/***/ }),

/***/ "./src/app/_shared/services/supplies.service.ts":
/*!******************************************************!*\
  !*** ./src/app/_shared/services/supplies.service.ts ***!
  \******************************************************/
/*! exports provided: SuppliesService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuppliesService", function() { return SuppliesService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");







let SuppliesService = class SuppliesService {
    constructor(afStore, storageService) {
        this.afStore = afStore;
        this.storageService = storageService;
        this.lookupSource = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]({});
        this.productLookup = this.lookupSource.asObservable();
        this.products = [];
        this.productDictionary = {};
    }
    getOrganizationProducts() {
        const organizationId = this.storageService.getOrganizationId();
        return this.afStore.collection('organizations').doc(organizationId)
            .collection('products').snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            const exists = a.payload.doc.exists;
            const product = Object.assign({ id, exists }, data);
            this.productDictionary[id] = product;
            return product;
        })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(list => {
            if (list.length !== 0) {
                this.products = list;
                this.lookupSource.next(this.productDictionary);
                return list;
            }
            return null;
        }));
    }
    getProductSource() {
        return this.lookupSource
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(data => {
            if (Object.keys(data).length === 0) {
                this.getOrganizationProducts()
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).subscribe();
            }
            return data;
        }));
    }
    getProductList() {
        if (this.products) {
            return this.products.slice();
        }
        else {
            return null;
        }
    }
    clearData() {
        this.lookupSource.next({});
        this.products = [];
    }
    addOrganizationProduct(product) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.afStore.collection('organizations').doc(organizationId)
            .collection('products').add(product))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = res.id;
            const exists = true;
            const newProduct = Object.assign({ id, exists }, product);
            this.productDictionary[id] = newProduct;
            this.products.push(newProduct);
            this.lookupSource.next(this.productDictionary);
            return newProduct;
        }));
    }
    updateOrganizationProduct(product, productId) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.afStore.collection('organizations').doc(organizationId)
            .collection('products').doc(productId).update(product))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const id = productId;
            const exists = true;
            const newProduct = Object.assign({ id, exists }, product);
            this.productDictionary[id] = newProduct;
            const idx = this.products.findIndex(x => x.id === productId);
            if (idx !== -1) {
                this.products[idx] = newProduct;
            }
            this.lookupSource.next(this.productDictionary);
            return newProduct;
        }));
    }
    deleteOrganizationProduct(productId) {
        const organizationId = this.storageService.getOrganizationId();
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.afStore.collection('organizations').doc(organizationId)
            .collection('products').doc(productId).delete())
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const idx = this.products.findIndex(x => x.id === productId);
            if (idx !== -1) {
                this.products.splice(idx, 1);
            }
            if (this.productDictionary.hasOwnProperty(productId)) {
                delete this.productDictionary[productId];
            }
            this.lookupSource.next(this.productDictionary);
            return res;
        }));
    }
};
SuppliesService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_6__["LocalStorageService"] }
];
SuppliesService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_6__["LocalStorageService"]])
], SuppliesService);



/***/ }),

/***/ "./src/app/_shared/services/tax-rate.service.ts":
/*!******************************************************!*\
  !*** ./src/app/_shared/services/tax-rate.service.ts ***!
  \******************************************************/
/*! exports provided: TaxRatesService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TaxRatesService", function() { return TaxRatesService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! services/local-storage.service */ "./src/app/_shared/services/local-storage.service.ts");
/* harmony import */ var rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/internal-compatibility */ "../../../node_modules/rxjs/_esm2015/internal-compatibility/index.js");






let TaxRatesService = class TaxRatesService {
    constructor(firestoreService, storageService) {
        this.firestoreService = firestoreService;
        this.storageService = storageService;
    }
    /**
     * Returns all accounting services for an Organization - used to populate the services
     * select
     */
    getTaxRates(limit) {
        const organizationId = this.storageService.getStorage('organizationId');
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('taxrates', ref => {
            let query = ref;
            query = query.orderBy('description', 'asc');
            if (limit) {
                query = query.limit(limit);
            }
            return query;
        }).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const exists = a.payload.doc.exists;
            const id = a.payload.doc.id;
            return Object.assign({ id, exists }, data);
        })));
    }
    // Get a single order by id
    getTaxRate(id) {
        const organizationId = this.storageService.getOrganizationId();
        return this.firestoreService.collection('organizations').doc(organizationId)
            .collection('taxrates').doc(id).get()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(res => {
            const taxRate = res.data();
            taxRate.exists = res.exists;
            taxRate.id = res.id;
            return taxRate;
        }));
    }
    addTaxRate(taxRate) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('taxrates').add(taxRate));
    }
    deleteTaxRate(taxRateId) {
        const organizationId = this.storageService.getStorage('organizationId');
        return Object(rxjs_internal_compatibility__WEBPACK_IMPORTED_MODULE_5__["fromPromise"])(this.firestoreService
            .collection('organizations').doc(organizationId)
            .collection('taxrates').doc(taxRateId).delete());
    }
};
TaxRatesService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] },
    { type: services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__["LocalStorageService"] }
];
TaxRatesService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"],
        services_local_storage_service__WEBPACK_IMPORTED_MODULE_4__["LocalStorageService"]])
], TaxRatesService);



/***/ }),

/***/ "./src/app/_shared/ui-services/ui-loader/ui-loader.module.ts":
/*!*******************************************************************!*\
  !*** ./src/app/_shared/ui-services/ui-loader/ui-loader.module.ts ***!
  \*******************************************************************/
/*! exports provided: UiLoaderModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UiLoaderModule", function() { return UiLoaderModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/overlay */ "../../../node_modules/@angular/cdk/esm2015/overlay.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/progress-spinner */ "../../../node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _ui_loader_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ui-loader.service */ "./src/app/_shared/ui-services/ui-loader/ui-loader.service.ts");






let UiLoaderModule = class UiLoaderModule {
};
UiLoaderModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_3__["OverlayModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatProgressSpinnerModule"],
        ],
        providers: [_ui_loader_service__WEBPACK_IMPORTED_MODULE_5__["UiLoaderService"]],
        entryComponents: [_angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatSpinner"]]
    })
], UiLoaderModule);



/***/ }),

/***/ "./src/app/_shared/ui-services/ui-loader/ui-loader.service.ts":
/*!********************************************************************!*\
  !*** ./src/app/_shared/ui-services/ui-loader/ui-loader.service.ts ***!
  \********************************************************************/
/*! exports provided: UiLoaderService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UiLoaderService", function() { return UiLoaderService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/overlay */ "../../../node_modules/@angular/cdk/esm2015/overlay.js");
/* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/portal */ "../../../node_modules/@angular/cdk/esm2015/portal.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/progress-spinner */ "../../../node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");







let UiLoaderService = class UiLoaderService {
    constructor(overlay) {
        this.overlay = overlay;
        this.overlayTopRef = this.cdkOverlayCreate();
        this.overlay$ = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
        this.isActive = false;
        this.overlay$
            .asObservable()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(val => val ? 1 : -1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["scan"])((acc, one) => (acc + one) >= 0 ? acc + one : 0, 0))
            .subscribe((res) => {
            if (res === 1) {
                this.showOverlay();
            }
            else if (res === 0) {
                this.overlayTopRef.hasAttached() ? this.stopOverlay() : null;
            }
        });
    }
    cdkOverlayCreate() {
        return this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'sk-backdrop',
            positionStrategy: this.overlay.position()
                .global()
                .centerHorizontally()
                .centerVertically()
        });
    }
    showOverlay() {
        if (!this.isActive) {
            this.overlayTopRef.attach(new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](_angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatSpinner"]));
            this.isActive = true;
        }
    }
    stopOverlay() {
        this.overlayTopRef.detach();
        this.isActive = false;
    }
};
UiLoaderService.ctorParameters = () => [
    { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__["Overlay"] }
];
UiLoaderService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__["Overlay"]])
], UiLoaderService);



/***/ }),

/***/ "./src/app/_shared/ui-services/ui-spinner/ui-spinner.module.ts":
/*!*********************************************************************!*\
  !*** ./src/app/_shared/ui-services/ui-spinner/ui-spinner.module.ts ***!
  \*********************************************************************/
/*! exports provided: UiSpinnerModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UiSpinnerModule", function() { return UiSpinnerModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/overlay */ "../../../node_modules/@angular/cdk/esm2015/overlay.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/progress-spinner */ "../../../node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _ui_spinner_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ui-spinner.service */ "./src/app/_shared/ui-services/ui-spinner/ui-spinner.service.ts");






let UiSpinnerModule = class UiSpinnerModule {
};
UiSpinnerModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_3__["OverlayModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatProgressSpinnerModule"],
        ],
        providers: [_ui_spinner_service__WEBPACK_IMPORTED_MODULE_5__["UiSpinnerService"]],
        entryComponents: [_angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatSpinner"]]
    })
], UiSpinnerModule);



/***/ }),

/***/ "./src/app/_shared/ui-services/ui-spinner/ui-spinner.service.ts":
/*!**********************************************************************!*\
  !*** ./src/app/_shared/ui-services/ui-spinner/ui-spinner.service.ts ***!
  \**********************************************************************/
/*! exports provided: UiSpinnerService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UiSpinnerService", function() { return UiSpinnerService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/overlay */ "../../../node_modules/@angular/cdk/esm2015/overlay.js");
/* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/cdk/portal */ "../../../node_modules/@angular/cdk/esm2015/portal.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/progress-spinner */ "../../../node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");







let UiSpinnerService = class UiSpinnerService {
    constructor(overlay) {
        this.overlay = overlay;
        this.spinnerTopRef = this.cdkSpinnerCreate();
        this.spin$ = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
        this.isActive = false;
        this.spin$
            .asObservable()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(val => val ? 1 : -1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["scan"])((acc, one) => (acc + one) >= 0 ? acc + one : 0, 0))
            .subscribe((res) => {
            if (res === 1) {
                this.showSpinner();
            }
            else if (res === 0) {
                this.spinnerTopRef.hasAttached() ? this.stopSpinner() : null;
            }
        });
    }
    cdkSpinnerCreate() {
        return this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'sk-backdrop',
            positionStrategy: this.overlay.position()
                .global()
                .centerHorizontally()
                .centerVertically()
        });
    }
    showSpinner() {
        if (!this.isActive) {
            this.spinnerTopRef.attach(new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_3__["ComponentPortal"](_angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_4__["MatSpinner"]));
            this.isActive = true;
        }
    }
    stopSpinner() {
        this.spinnerTopRef.detach();
        this.isActive = false;
    }
};
UiSpinnerService.ctorParameters = () => [
    { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__["Overlay"] }
];
UiSpinnerService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_2__["Overlay"]])
], UiSpinnerService);



/***/ }),

/***/ "./src/app/_shared/validators/autocomplete-validator.ts":
/*!**************************************************************!*\
  !*** ./src/app/_shared/validators/autocomplete-validator.ts ***!
  \**************************************************************/
/*! exports provided: AutoCompleteValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoCompleteValidator", function() { return AutoCompleteValidator; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");

function AutoCompleteValidator(control) {
    if ((control.value) && (control.value.id)) {
        return null;
    }
    else {
        return { required: true };
    }
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_guards_auth_guard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./_shared/guards/auth.guard */ "./src/app/_shared/guards/auth.guard.ts");
/* harmony import */ var _shared_guards_sign_out_guard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./_shared/guards/sign-out.guard */ "./src/app/_shared/guards/sign-out.guard.ts");





const routes = [
    {
        path: 'login',
        loadChildren: () => __webpack_require__.e(/*! import() | components-login-login-module */ "components-login-login-module").then(__webpack_require__.bind(null, /*! ./components/login/login.module */ "./src/app/components/login/login.module.ts")).then(m => m.LoginModule)
    },
    {
        path: 'signup',
        loadChildren: () => __webpack_require__.e(/*! import() | components-signup-signup-module */ "components-signup-signup-module").then(__webpack_require__.bind(null, /*! ./components/signup/signup.module */ "./src/app/components/signup/signup.module.ts")).then(m => m.SignupModule)
    },
    {
        path: 'no-access',
        loadChildren: () => __webpack_require__.e(/*! import() | components-no-access-no-access-module */ "components-no-access-no-access-module").then(__webpack_require__.bind(null, /*! ./components/no-access/no-access.module */ "./src/app/components/no-access/no-access.module.ts")).then(m => m.NoAccessModule)
    },
    {
        path: 'signout',
        canActivate: [_shared_guards_sign_out_guard__WEBPACK_IMPORTED_MODULE_4__["SignOutGuard"]],
        loadChildren: () => __webpack_require__.e(/*! import() | components-login-login-module */ "components-login-login-module").then(__webpack_require__.bind(null, /*! ./components/login/login.module */ "./src/app/components/login/login.module.ts")).then(m => m.LoginModule)
    },
    {
        path: 'office',
        canActivate: [_shared_guards_auth_guard__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]],
        loadChildren: () => __webpack_require__.e(/*! import() | _office-office-module */ "_office-office-module").then(__webpack_require__.bind(null, /*! ./_office/office.module */ "./src/app/_office/office.module.ts")).then(m => m.OfficeModule)
    },
    {
        path: 'invitation',
        loadChildren: () => __webpack_require__.e(/*! import() | components-invitation-invitation-module */ "components-invitation-invitation-module").then(__webpack_require__.bind(null, /*! ./components/invitation/invitation.module */ "./src/app/components/invitation/invitation.module.ts")).then(m => m.InvitationModule)
    },
    {
        path: 'invoice',
        loadChildren: () => Promise.resolve(/*! import() */).then(__webpack_require__.bind(null, /*! ./components/invoice-display/invoice-display.module */ "./src/app/components/invoice-display/invoice-display.module.ts")).then(m => m.InvoiceDisplayModule)
    },
    { path: '', redirectTo: '/office/dashboard', pathMatch: 'full' },
    { path: '**', redirectTo: '/office/dashboard', pathMatch: 'full' },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "../../../node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "../../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");




let AppComponent = class AppComponent {
    constructor(iconRegistry, sanitizer) {
        iconRegistry.addSvgIcon('dashboard', sanitizer.bypassSecurityTrustResourceUrl('assets/img/baseline_dashboard_navy_blue.svg'));
    }
    ngOnInit() {
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatIconRegistry"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'sk-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatIconRegistry"],
        _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "../../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser/animations */ "../../../node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _shared_guards_auth_guard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./_shared/guards/auth.guard */ "./src/app/_shared/guards/auth.guard.ts");
/* harmony import */ var _sk_custom_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @sk/custom-material */ "../../../libs/custom-material/src/index.ts");
/* harmony import */ var _angular_fire__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/fire */ "../../../node_modules/@angular/fire/es2015/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/fire/firestore */ "../../../node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/fire/auth */ "../../../node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_storage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/fire/storage */ "../../../node_modules/@angular/fire/storage/es2015/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/common/http */ "../../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var ngx_mask__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ngx-mask */ "../../../node_modules/ngx-mask/fesm2015/ngx-mask.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var shared_guards_sign_out_guard__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! shared/guards/sign-out.guard */ "./src/app/_shared/guards/sign-out.guard.ts");
/* harmony import */ var shared_ui_services_ui_spinner_ui_spinner_module__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! shared/ui-services/ui-spinner/ui-spinner.module */ "./src/app/_shared/ui-services/ui-spinner/ui-spinner.module.ts");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/core */ "../../../node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! moment */ "../../../node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var shared_guards_overview_guard_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! shared/guards/overview-guard.service */ "./src/app/_shared/guards/overview-guard.service.ts");
/* harmony import */ var _components_invoice_display_invoice_display_module__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/invoice-display/invoice-display.module */ "./src/app/components/invoice-display/invoice-display.module.ts");
/* harmony import */ var shared_http_interceptors__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! shared/http-interceptors */ "./src/app/_shared/http-interceptors/index.ts");
/* harmony import */ var shared_ui_services_ui_loader_ui_loader_module__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! shared/ui-services/ui-loader/ui-loader.module */ "./src/app/_shared/ui-services/ui-loader/ui-loader.module.ts");
























// registerLocaleData(environment.locale);
console.log('env.language ' + _environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].language);
Object(_angular_common__WEBPACK_IMPORTED_MODULE_15__["registerLocaleData"])(_environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].locale, _environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].language);
moment__WEBPACK_IMPORTED_MODULE_19__["locale"](_environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].language);
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["BrowserAnimationsModule"],
            _angular_fire__WEBPACK_IMPORTED_MODULE_8__["AngularFireModule"].initializeApp(_environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].firebase),
            _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_10__["AngularFirestoreModule"],
            _angular_fire_auth__WEBPACK_IMPORTED_MODULE_11__["AngularFireAuthModule"],
            _angular_fire_storage__WEBPACK_IMPORTED_MODULE_12__["AngularFireStorageModule"],
            // AngularFireMessagingModule, // imports firebase/messaging only needed for messaging features
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _sk_custom_material__WEBPACK_IMPORTED_MODULE_7__["CustomMaterialModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_13__["HttpClientModule"],
            shared_ui_services_ui_spinner_ui_spinner_module__WEBPACK_IMPORTED_MODULE_17__["UiSpinnerModule"],
            shared_ui_services_ui_loader_ui_loader_module__WEBPACK_IMPORTED_MODULE_23__["UiLoaderModule"],
            _components_invoice_display_invoice_display_module__WEBPACK_IMPORTED_MODULE_21__["InvoiceDisplayModule"],
            ngx_mask__WEBPACK_IMPORTED_MODULE_14__["NgxMaskModule"].forRoot()
        ],
        providers: [
            _shared_guards_auth_guard__WEBPACK_IMPORTED_MODULE_6__["AuthGuard"],
            shared_guards_sign_out_guard__WEBPACK_IMPORTED_MODULE_16__["SignOutGuard"],
            shared_guards_overview_guard_service__WEBPACK_IMPORTED_MODULE_20__["QueryParamsGuard"],
            shared_http_interceptors__WEBPACK_IMPORTED_MODULE_22__["httpInterceptorProviders"],
            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_2__["LOCALE_ID"], useValue: _environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].language },
            { provide: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_10__["FirestoreSettingsToken"], useValue: {} },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_18__["MAT_DATE_LOCALE"], useValue: _environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].language }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/invoice-display/invoice-display-routing.module.ts":
/*!******************************************************************************!*\
  !*** ./src/app/components/invoice-display/invoice-display-routing.module.ts ***!
  \******************************************************************************/
/*! exports provided: InvoiceDisplayRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceDisplayRoutingModule", function() { return InvoiceDisplayRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _invoice_display_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./invoice-display.component */ "./src/app/components/invoice-display/invoice-display.component.ts");




const routes = [
    {
        path: '',
        component: _invoice_display_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceDisplayComponent"]
    }
];
let InvoiceDisplayRoutingModule = class InvoiceDisplayRoutingModule {
};
InvoiceDisplayRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], InvoiceDisplayRoutingModule);



/***/ }),

/***/ "./src/app/components/invoice-display/invoice-display.component.scss":
/*!***************************************************************************!*\
  !*** ./src/app/components/invoice-display/invoice-display.component.scss ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHBzL2JhY2tvZmZpY2Uvd2ViLWFwcC9zcmMvYXBwL2NvbXBvbmVudHMvaW52b2ljZS1kaXNwbGF5L2ludm9pY2UtZGlzcGxheS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/components/invoice-display/invoice-display.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/invoice-display/invoice-display.component.ts ***!
  \*************************************************************************/
/*! exports provided: InvoiceDisplayComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceDisplayComponent", function() { return InvoiceDisplayComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "../../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var shared_services_location_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! shared/services/location.service */ "./src/app/_shared/services/location.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/dialog */ "../../../node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "../../../node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var environments_environment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var shared_services_invoice_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! shared/services/invoice.service */ "./src/app/_shared/services/invoice.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/router */ "../../../node_modules/@angular/router/fesm2015/router.js");










let InvoiceDisplayComponent = class InvoiceDisplayComponent {
    constructor(dialog, route, router, snackBar, locationService, invoiceService) {
        this.dialog = dialog;
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.locationService = locationService;
        this.invoiceService = invoiceService;
        this.onReady = false;
        this.gotData = false;
        this.locationLookup = {};
        this.invoiceId = '';
        this.organizationId = '';
        this.unsubscribe$ = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
    }
    ngOnInit() {
        this.getData();
        this.route.queryParams
            .subscribe(params => {
            console.log('params ' + JSON.stringify(params));
            this.invoiceId = params.invoiceId;
            this.organizationId = params.organizationId;
            console.log('invoice id is ' + this.invoiceId);
            console.log('org id is ' + this.organizationId);
            this.getInvoice();
        });
    }
    getInvoice() {
        this.invoiceService.getInvoiceWithOrganizationId(this.invoiceId, this.organizationId)
            .subscribe(invoice => {
            this.invoice = invoice;
            console.log('got invoice : ' + JSON.stringify(this.invoice));
            if (this.invoice) {
                this.onReady = true;
            }
            else {
                this.snackBar
                    .open('Could not find invoice', 'Error', {
                    duration: 3000
                });
            }
        }, error => {
            if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                console.error(error);
            }
        });
    }
    getData() {
        console.log('hi from getStaffAndLocations');
        this.locationService.getLocationSource()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["takeUntil"])(this.unsubscribe$))
            .subscribe(locationData => {
            if (locationData && (Object.keys(locationData).length !== 0)) {
                this.locationLookup = locationData;
                this.gotData = true;
            }
        }, error => {
            if (!environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production) {
                console.error(error);
            }
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
};
InvoiceDisplayComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_9__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_9__["Router"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: shared_services_location_service__WEBPACK_IMPORTED_MODULE_3__["LocationService"] },
    { type: shared_services_invoice_service__WEBPACK_IMPORTED_MODULE_8__["InvoiceService"] }
];
InvoiceDisplayComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'sk-invoice-display',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./invoice-display.component.html */ "../../../node_modules/raw-loader/dist/cjs.js!./src/app/components/invoice-display/invoice-display.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./invoice-display.component.scss */ "./src/app/components/invoice-display/invoice-display.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"],
        _angular_router__WEBPACK_IMPORTED_MODULE_9__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_9__["Router"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        shared_services_location_service__WEBPACK_IMPORTED_MODULE_3__["LocationService"],
        shared_services_invoice_service__WEBPACK_IMPORTED_MODULE_8__["InvoiceService"]])
], InvoiceDisplayComponent);



/***/ }),

/***/ "./src/app/components/invoice-display/invoice-display.module.ts":
/*!**********************************************************************!*\
  !*** ./src/app/components/invoice-display/invoice-display.module.ts ***!
  \**********************************************************************/
/*! exports provided: InvoiceDisplayModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvoiceDisplayModule", function() { return InvoiceDisplayModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "../../../node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _invoice_display_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./invoice-display.component */ "./src/app/components/invoice-display/invoice-display.component.ts");
/* harmony import */ var _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @sk/custom-material */ "../../../libs/custom-material/src/index.ts");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/flex-layout */ "../../../node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var shared_pipes_truncationPipe_truncationPipe_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! shared/pipes/truncationPipe/truncationPipe.module */ "./src/app/_shared/pipes/truncationPipe/truncationPipe.module.ts");
/* harmony import */ var shared_dialogs_alert_dialog_alert_dialog_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! shared/dialogs/alert-dialog/alert-dialog.module */ "./src/app/_shared/dialogs/alert-dialog/alert-dialog.module.ts");
/* harmony import */ var _office_invoicing_invoicing_overview_invoicing_dashboard_invoice_detail_invoice_detail_module__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.module */ "./src/app/_office/invoicing/invoicing-overview/invoicing-dashboard/invoice-detail/invoice-detail.module.ts");
/* harmony import */ var _invoice_display_routing_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./invoice-display-routing.module */ "./src/app/components/invoice-display/invoice-display-routing.module.ts");










let InvoiceDisplayModule = class InvoiceDisplayModule {
};
InvoiceDisplayModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_invoice_display_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceDisplayComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _sk_custom_material__WEBPACK_IMPORTED_MODULE_4__["CustomMaterialModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_5__["FlexLayoutModule"],
            _invoice_display_routing_module__WEBPACK_IMPORTED_MODULE_9__["InvoiceDisplayRoutingModule"],
            _office_invoicing_invoicing_overview_invoicing_dashboard_invoice_detail_invoice_detail_module__WEBPACK_IMPORTED_MODULE_8__["InvoiceDetailModule"],
            shared_dialogs_alert_dialog_alert_dialog_module__WEBPACK_IMPORTED_MODULE_7__["AlertDialogModule"],
            shared_pipes_truncationPipe_truncationPipe_module__WEBPACK_IMPORTED_MODULE_6__["TruncationPipeModule"],
        ],
        providers: [],
        exports: [_invoice_display_component__WEBPACK_IMPORTED_MODULE_3__["InvoiceDisplayComponent"]]
    })
], InvoiceDisplayModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_locales_en__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/locales/en */ "../../../node_modules/@angular/common/locales/en.js");
/* harmony import */ var _angular_common_locales_en__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_angular_common_locales_en__WEBPACK_IMPORTED_MODULE_1__);

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    language: 'en-US',
    scheduleCheck: false,
    region: 'us',
    locale: _angular_common_locales_en__WEBPACK_IMPORTED_MODULE_1___default.a,
    firebase: {
        apiKey: 'AIzaSyASqbYrwNmF8cJqonY6wSA82pQ6J-JE6WA',
        authDomain: 'servicekicker-dev.firebaseapp.com',
        databaseURL: 'https://servicekicker-dev.firebaseio.com',
        projectId: 'servicekicker-dev',
        storageBucket: 'servicekicker-dev.appspot.com',
        messagingSenderId: '296370750205'
    },
    api_url: 'https://us-central1-servicekicker-dev.cloudfunctions.net',
    base_url: 'https://dev.servicekicker.com',
    release: 'dev 0.0.28'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "../../../node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! hammerjs */ "../../../node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_5__);






if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])()
    .bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => {
    if (!_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
        console.error(err);
    }
});


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! D:\Industrylinq\servicekicker\apps\backoffice\web-app\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map